import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTImageToSDKImage } from '@wix/sdk-runtime/transformations/image';
import { transformRESTPageURLV2ToSDKPageURLV2 } from '@wix/sdk-runtime/transformations/page-url-v2';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { transformRESTVideoV2ToSDKVideoV2 } from '@wix/sdk-runtime/transformations/video-v2';
import { EventDefinition, HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  BulkAddInfoSectionsToProductsApplicationErrors,
  BulkAddInfoSectionsToProductsByFilterApplicationErrors,
  BulkAddInfoSectionsToProductsByFilterOptions,
  BulkAddInfoSectionsToProductsOptions,
  BulkAddProductsToCategoriesByFilterOptions,
  BulkAddProductsToCategoriesByFilterResponse,
  BulkAdjustProductVariantsByFilterApplicationErrors,
  BulkAdjustProductVariantsByFilterOptions,
  BulkAdjustProductVariantsByFilterValidationErrors,
  BulkCreateProductsApplicationErrors,
  BulkCreateProductsOptions,
  BulkCreateProductsResponse,
  BulkCreateProductsValidationErrors,
  BulkCreateProductsWithInventoryApplicationErrors,
  BulkCreateProductsWithInventoryOptions,
  BulkCreateProductsWithInventoryResponse,
  BulkCreateProductsWithInventoryValidationErrors,
  BulkDeleteProductsByFilterOptions,
  BulkDeleteProductsValidationErrors,
  BulkRemoveInfoSectionsFromProductsByFilterOptions,
  BulkRemoveInfoSectionsFromProductsOptions,
  BulkRemoveProductsFromCategoriesByFilterOptions,
  BulkRemoveProductsFromCategoriesByFilterResponse,
  BulkUpdateProductTagsApplicationErrors,
  BulkUpdateProductTagsByFilterApplicationErrors,
  BulkUpdateProductTagsByFilterOptions,
  BulkUpdateProductTagsOptions,
  BulkUpdateProductVariantsByFilterApplicationErrors,
  BulkUpdateProductVariantsByFilterOptions,
  BulkUpdateProductVariantsByFilterResponse,
  BulkUpdateProductVariantsByFilterValidationErrors,
  BulkUpdateProductsApplicationErrors,
  BulkUpdateProductsByFilterApplicationErrors,
  BulkUpdateProductsByFilterOptions,
  BulkUpdateProductsByFilterValidationErrors,
  BulkUpdateProductsOptions,
  BulkUpdateProductsResponse,
  BulkUpdateProductsValidationErrors,
  BulkUpdateProductsWithInventoryApplicationErrors,
  BulkUpdateProductsWithInventoryOptions,
  BulkUpdateProductsWithInventoryResponse,
  BulkUpdateProductsWithInventoryValidationErrors,
  CountProductsApplicationErrors,
  CountProductsOptions,
  CreateProductApplicationErrors,
  CreateProductOptions,
  CreateProductValidationErrors,
  CreateProductWithInventoryApplicationErrors,
  CreateProductWithInventoryOptions,
  CreateProductWithInventoryResponse,
  CreateProductWithInventoryValidationErrors,
  GetAllProductsCategoryResponse,
  GetProductApplicationErrors,
  GetProductBySlugApplicationErrors,
  GetProductBySlugOptions,
  GetProductOptions,
  MaskedProductWithInventory,
  ProductCreatedEnvelope,
  ProductDeletedEnvelope,
  ProductUpdatedEnvelope,
  ProductWithInventory,
  ProductsQueryBuilder,
  QueryProductsApplicationErrors,
  QueryProductsOptions,
  SearchProductsApplicationErrors,
  SearchProductsOptions,
  UpdateProduct,
  UpdateProductApplicationErrors,
  UpdateProductOptions,
  UpdateProductValidationErrors,
  UpdateProductWithInventoryApplicationErrors,
  UpdateProductWithInventoryOptions,
  UpdateProductWithInventoryProduct,
  UpdateProductWithInventoryResponse,
  UpdateProductWithInventoryValidationErrors,
  V3BulkAddInfoSectionsToProductsByFilterResponse,
  V3BulkAddInfoSectionsToProductsResponse,
  V3BulkAdjustProductVariantsByFilterResponse,
  V3BulkDeleteProductsByFilterResponse,
  V3BulkDeleteProductsResponse,
  V3BulkRemoveInfoSectionsFromProductsByFilterResponse,
  V3BulkRemoveInfoSectionsFromProductsResponse,
  V3BulkUpdateProductTagsByFilterResponse,
  V3BulkUpdateProductTagsResponse,
  V3BulkUpdateProductsByFilterResponse,
  V3CountProductsResponse,
  V3GetProductBySlugResponse,
  V3MaskedProduct,
  V3Product,
  V3ProductIdWithRevision,
  V3ProductQuery,
  V3ProductSearch,
  V3QueryProductsResponse,
  V3SearchProductsResponse,
  bulkAddInfoSectionsToProducts as universalBulkAddInfoSectionsToProducts,
  bulkAddInfoSectionsToProductsByFilter as universalBulkAddInfoSectionsToProductsByFilter,
  bulkAddProductsToCategoriesByFilter as universalBulkAddProductsToCategoriesByFilter,
  bulkAdjustProductVariantsByFilter as universalBulkAdjustProductVariantsByFilter,
  bulkCreateProducts as universalBulkCreateProducts,
  bulkCreateProductsWithInventory as universalBulkCreateProductsWithInventory,
  bulkDeleteProducts as universalBulkDeleteProducts,
  bulkDeleteProductsByFilter as universalBulkDeleteProductsByFilter,
  bulkRemoveInfoSectionsFromProducts as universalBulkRemoveInfoSectionsFromProducts,
  bulkRemoveInfoSectionsFromProductsByFilter as universalBulkRemoveInfoSectionsFromProductsByFilter,
  bulkRemoveProductsFromCategoriesByFilter as universalBulkRemoveProductsFromCategoriesByFilter,
  bulkUpdateProductTags as universalBulkUpdateProductTags,
  bulkUpdateProductTagsByFilter as universalBulkUpdateProductTagsByFilter,
  bulkUpdateProductVariantsByFilter as universalBulkUpdateProductVariantsByFilter,
  bulkUpdateProducts as universalBulkUpdateProducts,
  bulkUpdateProductsByFilter as universalBulkUpdateProductsByFilter,
  bulkUpdateProductsWithInventory as universalBulkUpdateProductsWithInventory,
  countProducts as universalCountProducts,
  createProduct as universalCreateProduct,
  createProductWithInventory as universalCreateProductWithInventory,
  deleteProduct as universalDeleteProduct,
  getAllProductsCategory as universalGetAllProductsCategory,
  getProduct as universalGetProduct,
  getProductBySlug as universalGetProductBySlug,
  queryProducts as universalQueryProducts,
  searchProducts as universalSearchProducts,
  typedQueryProducts as universalTypedQueryProducts,
  updateProduct as universalUpdateProduct,
  updateProductWithInventory as universalUpdateProductWithInventory,
} from './stores-catalog-v3-product-products-v-3.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/stores' };

export function createProduct(httpClient: HttpClient): CreateProductSignature {
  return (
    product: NonNullablePaths<
      V3Product,
      | `modifiers.${number}.choicesSettings.choices`
      | `name`
      | `options.${number}.choicesSettings.choices`
      | `physicalProperties.pricePerUnit.measurementUnit`
      | `productType`
      | `subscriptionDetails.subscriptions`
      | `subscriptionDetails.subscriptions.${number}.discount.type`
      | `subscriptionDetails.subscriptions.${number}.frequency`
      | `subscriptionDetails.subscriptions.${number}.title`
      | `variantsInfo`
      | `variantsInfo.variants`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.choiceId`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.optionId`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `variantsInfo.variants.${number}.physicalProperties.packageDimensions.unit`
      | `variantsInfo.variants.${number}.physicalProperties.pricePerUnit.settings.measurementUnit`
      | `variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `variantsInfo.variants.${number}.price`
      | `variantsInfo.variants.${number}.price.actualPrice`,
      8
    >,
    options?: CreateProductOptions
  ) =>
    universalCreateProduct(
      product,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface CreateProductSignature {
  /**
   * Creates a new product.
   *
   * You can also add a ribbon, brand, info sections, options, and modifiers in the same request.
   *
   * > **Notes:**
   * > + This method doesn't create inventory items. Use [Create Product With Inventory](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/products-v3/create-product-with-inventory) to create a product with inventory in a single call, or create inventory items separately using the [Inventory Items API](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/inventory-items-v3/introduction).
   * > + When you create a product with inline options or modifiers (without referencing existing customization IDs), new standalone [Customization](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/customizations-v3/introduction) entities are automatically created. These can be reused across other products.
   * @param - Product to create.
   *
   * At least 1 variant must be provided, and each variant must have an item in the `choices` field for every item in `options`.
   * If `options` is empty, 1 default variant must be provided with an empty `choices` list.
   * @returns Created product.
   */
  (
    product: NonNullablePaths<
      V3Product,
      | `modifiers.${number}.choicesSettings.choices`
      | `name`
      | `options.${number}.choicesSettings.choices`
      | `physicalProperties.pricePerUnit.measurementUnit`
      | `productType`
      | `subscriptionDetails.subscriptions`
      | `subscriptionDetails.subscriptions.${number}.discount.type`
      | `subscriptionDetails.subscriptions.${number}.frequency`
      | `subscriptionDetails.subscriptions.${number}.title`
      | `variantsInfo`
      | `variantsInfo.variants`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.choiceId`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.optionId`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `variantsInfo.variants.${number}.physicalProperties.packageDimensions.unit`
      | `variantsInfo.variants.${number}.physicalProperties.pricePerUnit.settings.measurementUnit`
      | `variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `variantsInfo.variants.${number}.price`
      | `variantsInfo.variants.${number}.price.actualPrice`,
      8
    >,
    options?: CreateProductOptions
  ): Promise<
    NonNullablePaths<
      V3Product,
      | `physicalProperties.pricePerUnit.quantity`
      | `physicalProperties.pricePerUnit.measurementUnit`
      | `physicalProperties.shippingWeightRange.minValue`
      | `physicalProperties.shippingWeightRange.maxValue`
      | `physicalProperties.pricePerUnitRange.minValue.value`
      | `physicalProperties.weightMeasurementUnitInfo.weightMeasurementUnit`
      | `media.main._id`
      | `media.main.url`
      | `media.main.mediaType`
      | `media.main.thumbnail.url`
      | `media.main.thumbnail.height`
      | `media.main.thumbnail.width`
      | `media.main.uploadId`
      | `media.itemsInfo.items`
      | `seoData.tags`
      | `seoData.tags.${number}.type`
      | `seoData.tags.${number}.children`
      | `seoData.tags.${number}.custom`
      | `seoData.tags.${number}.disabled`
      | `seoData.settings.preventAutoRedirect`
      | `seoData.settings.keywords`
      | `seoData.settings.keywords.${number}.term`
      | `seoData.settings.keywords.${number}.isMain`
      | `options`
      | `options.${number}.optionRenderType`
      | `options.${number}.key`
      | `modifiers`
      | `modifiers.${number}.freeTextSettings.minCharCount`
      | `modifiers.${number}.freeTextSettings.maxCharCount`
      | `modifiers.${number}.freeTextSettings.title`
      | `modifiers.${number}.freeTextSettings.key`
      | `modifiers.${number}.modifierRenderType`
      | `modifiers.${number}.mandatory`
      | `modifiers.${number}.key`
      | `infoSections`
      | `directCategoriesInfo.categories`
      | `directCategoriesInfo.categories.${number}._id`
      | `costRange.minValue.amount`
      | `inventory.availabilityStatus`
      | `inventory.preorderStatus`
      | `inventory.preorderAvailability`
      | `productType`
      | `breadcrumbsInfo.breadcrumbs`
      | `breadcrumbsInfo.breadcrumbs.${number}.categoryId`
      | `breadcrumbsInfo.breadcrumbs.${number}.categoryName`
      | `breadcrumbsInfo.breadcrumbs.${number}.categorySlug`
      | `variantsInfo.variants`
      | `variantsInfo.variants.${number}.physicalProperties.pricePerUnit.value`
      | `variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile.fileName`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile.fileType`
      | `variantsInfo.variants.${number}.revenueDetails.profitMargin`
      | `variantsInfo.variants.${number}.inventoryStatus.inStock`
      | `variantsInfo.variants.${number}.inventoryStatus.preorderEnabled`
      | `purchaseEligibility.userCriteria`
      | `additionalRibbons`
      | `tags.privateTags.tagIds`
      | `subscriptionDetails.subscriptions`
      | `subscriptionDetails.subscriptions.${number}.autoRenewal`
      | `subscriptionDetails.subscriptions.${number}.billingCycles`
      | `subscriptionDetails.subscriptions.${number}.title`
      | `subscriptionDetails.subscriptions.${number}.frequency`
      | `subscriptionDetails.subscriptions.${number}.discount.amountOff`
      | `subscriptionDetails.subscriptions.${number}.discount.percentOff`
      | `subscriptionDetails.subscriptions.${number}.discount.type`
      | `variantSummary.variantCount`,
      7
    > & {
      __applicationErrorsType?: CreateProductApplicationErrors;
      __validationErrorsType?: CreateProductValidationErrors;
    }
  >;
}

export function createProductWithInventory(
  httpClient: HttpClient
): CreateProductWithInventorySignature {
  return (
    product: NonNullablePaths<
      ProductWithInventory,
      | `modifiers.${number}.choicesSettings.choices`
      | `name`
      | `options.${number}.choicesSettings.choices`
      | `physicalProperties.pricePerUnit.measurementUnit`
      | `productType`
      | `subscriptionDetails.subscriptions`
      | `subscriptionDetails.subscriptions.${number}.discount.type`
      | `subscriptionDetails.subscriptions.${number}.frequency`
      | `subscriptionDetails.subscriptions.${number}.title`
      | `variantsInfo`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.choiceId`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.optionId`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `variantsInfo.variants.${number}.physicalProperties.packageDimensions.unit`
      | `variantsInfo.variants.${number}.physicalProperties.pricePerUnit.settings.measurementUnit`
      | `variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `variantsInfo.variants.${number}.price`
      | `variantsInfo.variants.${number}.price.actualPrice`,
      8
    >,
    options?: CreateProductWithInventoryOptions
  ) =>
    universalCreateProductWithInventory(
      product,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface CreateProductWithInventorySignature {
  /**
   * Creates a new product with its inventory in a single call.
   *
   * Pass `variantsInfo.variants.inventoryItem` to create inventory items for each variant in the default location. Each inventory item can track stock using either `quantity` (for exact stock counts) or `inStock` (for simple availability). If `inventoryItem` isn't provided, no inventory items are created.
   *
   * You can also add a ribbon, brand, info sections, options, and modifiers in the same request.
   *
   * Learn more about [inventory management](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/about-inventory-management) including tracking methods, preorder settings, and multi-location inventory.
   *
   * > **Note:** When you create a product with inline options or modifiers (without referencing existing customization IDs), new standalone [Customization](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/customizations-v3/introduction) entities are automatically created. These can be reused across other products.
   * @param - Product to create with inventory.
   *
   * At least one variant must be provided and each variant must have relevant item in `choices` field for every item in `options`.
   * If `options` is empty one default variant must be provided with empty `choices` list.
   */
  (
    product: NonNullablePaths<
      ProductWithInventory,
      | `modifiers.${number}.choicesSettings.choices`
      | `name`
      | `options.${number}.choicesSettings.choices`
      | `physicalProperties.pricePerUnit.measurementUnit`
      | `productType`
      | `subscriptionDetails.subscriptions`
      | `subscriptionDetails.subscriptions.${number}.discount.type`
      | `subscriptionDetails.subscriptions.${number}.frequency`
      | `subscriptionDetails.subscriptions.${number}.title`
      | `variantsInfo`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.choiceId`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.optionId`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `variantsInfo.variants.${number}.physicalProperties.packageDimensions.unit`
      | `variantsInfo.variants.${number}.physicalProperties.pricePerUnit.settings.measurementUnit`
      | `variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `variantsInfo.variants.${number}.price`
      | `variantsInfo.variants.${number}.price.actualPrice`,
      8
    >,
    options?: CreateProductWithInventoryOptions
  ): Promise<
    NonNullablePaths<
      CreateProductWithInventoryResponse,
      | `product.physicalProperties.pricePerUnit.quantity`
      | `product.physicalProperties.pricePerUnit.measurementUnit`
      | `product.physicalProperties.shippingWeightRange.minValue`
      | `product.physicalProperties.shippingWeightRange.maxValue`
      | `product.physicalProperties.pricePerUnitRange.minValue.value`
      | `product.physicalProperties.weightMeasurementUnitInfo.weightMeasurementUnit`
      | `product.media.main._id`
      | `product.media.main.url`
      | `product.media.main.mediaType`
      | `product.media.main.thumbnail.url`
      | `product.media.main.thumbnail.height`
      | `product.media.main.thumbnail.width`
      | `product.media.main.uploadId`
      | `product.media.itemsInfo.items`
      | `product.seoData.tags`
      | `product.seoData.tags.${number}.type`
      | `product.seoData.tags.${number}.children`
      | `product.seoData.tags.${number}.custom`
      | `product.seoData.tags.${number}.disabled`
      | `product.seoData.settings.preventAutoRedirect`
      | `product.seoData.settings.keywords`
      | `product.seoData.settings.keywords.${number}.term`
      | `product.seoData.settings.keywords.${number}.isMain`
      | `product.options`
      | `product.options.${number}.optionRenderType`
      | `product.options.${number}.key`
      | `product.modifiers`
      | `product.modifiers.${number}.freeTextSettings.minCharCount`
      | `product.modifiers.${number}.freeTextSettings.maxCharCount`
      | `product.modifiers.${number}.freeTextSettings.title`
      | `product.modifiers.${number}.freeTextSettings.key`
      | `product.modifiers.${number}.modifierRenderType`
      | `product.modifiers.${number}.mandatory`
      | `product.modifiers.${number}.key`
      | `product.infoSections`
      | `product.directCategoriesInfo.categories`
      | `product.directCategoriesInfo.categories.${number}._id`
      | `product.costRange.minValue.amount`
      | `product.inventory.availabilityStatus`
      | `product.inventory.preorderStatus`
      | `product.inventory.preorderAvailability`
      | `product.productType`
      | `product.breadcrumbsInfo.breadcrumbs`
      | `product.breadcrumbsInfo.breadcrumbs.${number}.categoryId`
      | `product.breadcrumbsInfo.breadcrumbs.${number}.categoryName`
      | `product.breadcrumbsInfo.breadcrumbs.${number}.categorySlug`
      | `product.variantsInfo.variants`
      | `product.variantsInfo.variants.${number}.physicalProperties.pricePerUnit.value`
      | `product.variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile.fileName`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile.fileType`
      | `product.variantsInfo.variants.${number}.revenueDetails.profitMargin`
      | `product.variantsInfo.variants.${number}.inventoryStatus.inStock`
      | `product.variantsInfo.variants.${number}.inventoryStatus.preorderEnabled`
      | `product.purchaseEligibility.userCriteria`
      | `product.additionalRibbons`
      | `product.tags.privateTags.tagIds`
      | `product.subscriptionDetails.subscriptions`
      | `product.subscriptionDetails.subscriptions.${number}.autoRenewal`
      | `product.subscriptionDetails.subscriptions.${number}.billingCycles`
      | `product.subscriptionDetails.subscriptions.${number}.title`
      | `product.subscriptionDetails.subscriptions.${number}.frequency`
      | `product.subscriptionDetails.subscriptions.${number}.discount.amountOff`
      | `product.subscriptionDetails.subscriptions.${number}.discount.percentOff`
      | `product.subscriptionDetails.subscriptions.${number}.discount.type`
      | `product.variantSummary.variantCount`
      | `inventoryResults.results`
      | `inventoryResults.results.${number}.itemMetadata.originalIndex`
      | `inventoryResults.results.${number}.itemMetadata.success`
      | `inventoryResults.results.${number}.itemMetadata.error.code`
      | `inventoryResults.results.${number}.itemMetadata.error.description`
      | `inventoryResults.results.${number}.item.inStock`
      | `inventoryResults.results.${number}.item.quantity`
      | `inventoryResults.results.${number}.item.variantId`
      | `inventoryResults.results.${number}.item.productId`
      | `inventoryResults.results.${number}.item.trackQuantity`
      | `inventoryResults.results.${number}.item.availabilityStatus`
      | `inventoryResults.bulkActionMetadata.totalSuccesses`
      | `inventoryResults.bulkActionMetadata.totalFailures`
      | `inventoryResults.bulkActionMetadata.undetailedFailures`,
      8
    > & {
      __applicationErrorsType?: CreateProductWithInventoryApplicationErrors;
      __validationErrorsType?: CreateProductWithInventoryValidationErrors;
    }
  >;
}

export function updateProduct(httpClient: HttpClient): UpdateProductSignature {
  return (
    _id: string,
    product: NonNullablePaths<
      UpdateProduct,
      | `modifiers.${number}.choicesSettings.choices`
      | `options.${number}.choicesSettings.choices`
      | `physicalProperties.pricePerUnit.measurementUnit`
      | `revision`
      | `subscriptionDetails.subscriptions.${number}.discount.type`
      | `subscriptionDetails.subscriptions.${number}.frequency`
      | `subscriptionDetails.subscriptions.${number}.title`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.choiceId`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.optionId`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `variantsInfo.variants.${number}.physicalProperties.packageDimensions.unit`
      | `variantsInfo.variants.${number}.physicalProperties.pricePerUnit.settings.measurementUnit`
      | `variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `variantsInfo.variants.${number}.price`
      | `variantsInfo.variants.${number}.price.actualPrice`,
      8
    >,
    options?: UpdateProductOptions
  ) =>
    universalUpdateProduct(
      _id,
      product,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface UpdateProductSignature {
  /**
   * Updates a product.
   *
   * Each time the product is updated, `revision` increments by 1.
   * The current `revision` must be passed when updating the product.
   * This ensures you're working with the latest product and prevents unintended overwrites.
   *
   * >**Notes:**
   * > + To update array fields like `options`, `modifiers`, `variantsInfo.variants`, and any others, you must pass the entire existing array. Passing only the changed item overwrites the entire array, not just merge the single change.
   * > + To update `variantsInfo.variants` you must also pass `options` and vice versa. This is because variants and options are mutually dependent and must be aligned.
   * > + To update existing `variantsInfo.variants`, make sure to provide `variantsInfo.variants.id`. If no ID is passed, a variant is created with a new ID.
   * > + Updating media per variant isn't supported. Instead, assign media items to product option choices using the `linkedMedia` field. You must use preexisting product media.
   * > + Partial-update semantics: Update Product supports partial updates with the following rules:
   * >   - At the request level, only `product`, `product.id`, and `product.revision` are required.
   * >   - Other fields shown as required in the schema apply only when their parent field is provided.
   * >   - Top-level fields you omit (for example, `name`, `ribbon`, `brand`, `taxGroupId`) are left unchanged.
   * >   - The full-array overwrite rule applies only to repeated fields (`options`, `modifiers`, `variantsInfo.variants`); top-level scalar and object fields are partially updatable on their own.
   * >   - To assign or change a brand without touching any other field, specify only `id`, `revision`, and `brand.id`. Supplying `brand.name` without `brand.id` is rejected with a `BRAND_MISSING_ID` validation error.
   * @param - Product ID.
   * @returns Updated product.
   */
  (
    _id: string,
    product: NonNullablePaths<
      UpdateProduct,
      | `modifiers.${number}.choicesSettings.choices`
      | `options.${number}.choicesSettings.choices`
      | `physicalProperties.pricePerUnit.measurementUnit`
      | `revision`
      | `subscriptionDetails.subscriptions.${number}.discount.type`
      | `subscriptionDetails.subscriptions.${number}.frequency`
      | `subscriptionDetails.subscriptions.${number}.title`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.choiceId`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.optionId`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `variantsInfo.variants.${number}.physicalProperties.packageDimensions.unit`
      | `variantsInfo.variants.${number}.physicalProperties.pricePerUnit.settings.measurementUnit`
      | `variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `variantsInfo.variants.${number}.price`
      | `variantsInfo.variants.${number}.price.actualPrice`,
      8
    >,
    options?: UpdateProductOptions
  ): Promise<
    NonNullablePaths<
      V3Product,
      | `physicalProperties.pricePerUnit.quantity`
      | `physicalProperties.pricePerUnit.measurementUnit`
      | `physicalProperties.shippingWeightRange.minValue`
      | `physicalProperties.shippingWeightRange.maxValue`
      | `physicalProperties.pricePerUnitRange.minValue.value`
      | `physicalProperties.weightMeasurementUnitInfo.weightMeasurementUnit`
      | `media.main._id`
      | `media.main.url`
      | `media.main.mediaType`
      | `media.main.thumbnail.url`
      | `media.main.thumbnail.height`
      | `media.main.thumbnail.width`
      | `media.main.uploadId`
      | `media.itemsInfo.items`
      | `seoData.tags`
      | `seoData.tags.${number}.type`
      | `seoData.tags.${number}.children`
      | `seoData.tags.${number}.custom`
      | `seoData.tags.${number}.disabled`
      | `seoData.settings.preventAutoRedirect`
      | `seoData.settings.keywords`
      | `seoData.settings.keywords.${number}.term`
      | `seoData.settings.keywords.${number}.isMain`
      | `options`
      | `options.${number}.optionRenderType`
      | `options.${number}.key`
      | `modifiers`
      | `modifiers.${number}.freeTextSettings.minCharCount`
      | `modifiers.${number}.freeTextSettings.maxCharCount`
      | `modifiers.${number}.freeTextSettings.title`
      | `modifiers.${number}.freeTextSettings.key`
      | `modifiers.${number}.modifierRenderType`
      | `modifiers.${number}.mandatory`
      | `modifiers.${number}.key`
      | `infoSections`
      | `directCategoriesInfo.categories`
      | `directCategoriesInfo.categories.${number}._id`
      | `costRange.minValue.amount`
      | `inventory.availabilityStatus`
      | `inventory.preorderStatus`
      | `inventory.preorderAvailability`
      | `productType`
      | `breadcrumbsInfo.breadcrumbs`
      | `breadcrumbsInfo.breadcrumbs.${number}.categoryId`
      | `breadcrumbsInfo.breadcrumbs.${number}.categoryName`
      | `breadcrumbsInfo.breadcrumbs.${number}.categorySlug`
      | `variantsInfo.variants`
      | `variantsInfo.variants.${number}.physicalProperties.pricePerUnit.value`
      | `variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile.fileName`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile.fileType`
      | `variantsInfo.variants.${number}.revenueDetails.profitMargin`
      | `variantsInfo.variants.${number}.inventoryStatus.inStock`
      | `variantsInfo.variants.${number}.inventoryStatus.preorderEnabled`
      | `purchaseEligibility.userCriteria`
      | `additionalRibbons`
      | `tags.privateTags.tagIds`
      | `subscriptionDetails.subscriptions`
      | `subscriptionDetails.subscriptions.${number}.autoRenewal`
      | `subscriptionDetails.subscriptions.${number}.billingCycles`
      | `subscriptionDetails.subscriptions.${number}.title`
      | `subscriptionDetails.subscriptions.${number}.frequency`
      | `subscriptionDetails.subscriptions.${number}.discount.amountOff`
      | `subscriptionDetails.subscriptions.${number}.discount.percentOff`
      | `subscriptionDetails.subscriptions.${number}.discount.type`
      | `variantSummary.variantCount`,
      7
    > & {
      __applicationErrorsType?: UpdateProductApplicationErrors;
      __validationErrorsType?: UpdateProductValidationErrors;
    }
  >;
}

export function updateProductWithInventory(
  httpClient: HttpClient
): UpdateProductWithInventorySignature {
  return (
    _id: string,
    product: NonNullablePaths<
      UpdateProductWithInventoryProduct,
      | `modifiers.${number}.choicesSettings.choices`
      | `options.${number}.choicesSettings.choices`
      | `physicalProperties.pricePerUnit.measurementUnit`
      | `revision`
      | `subscriptionDetails.subscriptions.${number}.discount.type`
      | `subscriptionDetails.subscriptions.${number}.frequency`
      | `subscriptionDetails.subscriptions.${number}.title`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.choiceId`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.optionId`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `variantsInfo.variants.${number}.physicalProperties.packageDimensions.unit`
      | `variantsInfo.variants.${number}.physicalProperties.pricePerUnit.settings.measurementUnit`
      | `variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `variantsInfo.variants.${number}.price`
      | `variantsInfo.variants.${number}.price.actualPrice`,
      8
    >,
    options?: UpdateProductWithInventoryOptions
  ) =>
    universalUpdateProductWithInventory(
      _id,
      product,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface UpdateProductWithInventorySignature {
  /**
   * Updates a product and its inventory in a single call.
   *
   * Each time the product is updated, `revision` increments by 1.
   * The current `revision` must be passed when updating the product.
   * This ensures you're working with the latest product and prevents unintended overwrites.
   *
   * Each inventory item can track stock using either `quantity` (for exact stock counts) or `inStock` (for simple availability). Learn more about [inventory management](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/about-inventory-management) including tracking methods, preorder settings, and multi-location inventory.
   *
   * >**Notes:**
   * > + To update array fields like `options`, `modifiers`, `variantsInfo.variants`, and any others, you must pass the entire existing array. Passing only the changed item overwrites the entire array, not just merge the single change.
   * > + To update `variantsInfo.variants` you must also pass `options` and vice versa. This is because variants and options are mutually dependent and must be aligned.
   * > + To update existing `variantsInfo.variants`, make sure to provide `variantsInfo.variants.id`. If no ID is passed, a variant is created with a new ID.
   * > + Updating media per variant isn't supported. Instead, assign media items to product option choices using the `linkedMedia` field. You must use preexisting product media.
   * @param - Product ID.
   */
  (
    _id: string,
    product: NonNullablePaths<
      UpdateProductWithInventoryProduct,
      | `modifiers.${number}.choicesSettings.choices`
      | `options.${number}.choicesSettings.choices`
      | `physicalProperties.pricePerUnit.measurementUnit`
      | `revision`
      | `subscriptionDetails.subscriptions.${number}.discount.type`
      | `subscriptionDetails.subscriptions.${number}.frequency`
      | `subscriptionDetails.subscriptions.${number}.title`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.choiceId`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.optionId`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `variantsInfo.variants.${number}.physicalProperties.packageDimensions.unit`
      | `variantsInfo.variants.${number}.physicalProperties.pricePerUnit.settings.measurementUnit`
      | `variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `variantsInfo.variants.${number}.price`
      | `variantsInfo.variants.${number}.price.actualPrice`,
      8
    >,
    options?: UpdateProductWithInventoryOptions
  ): Promise<
    NonNullablePaths<
      UpdateProductWithInventoryResponse,
      | `product.physicalProperties.pricePerUnit.quantity`
      | `product.physicalProperties.pricePerUnit.measurementUnit`
      | `product.physicalProperties.shippingWeightRange.minValue`
      | `product.physicalProperties.shippingWeightRange.maxValue`
      | `product.physicalProperties.pricePerUnitRange.minValue.value`
      | `product.physicalProperties.weightMeasurementUnitInfo.weightMeasurementUnit`
      | `product.media.main._id`
      | `product.media.main.url`
      | `product.media.main.mediaType`
      | `product.media.main.thumbnail.url`
      | `product.media.main.thumbnail.height`
      | `product.media.main.thumbnail.width`
      | `product.media.main.uploadId`
      | `product.media.itemsInfo.items`
      | `product.seoData.tags`
      | `product.seoData.tags.${number}.type`
      | `product.seoData.tags.${number}.children`
      | `product.seoData.tags.${number}.custom`
      | `product.seoData.tags.${number}.disabled`
      | `product.seoData.settings.preventAutoRedirect`
      | `product.seoData.settings.keywords`
      | `product.seoData.settings.keywords.${number}.term`
      | `product.seoData.settings.keywords.${number}.isMain`
      | `product.options`
      | `product.options.${number}.optionRenderType`
      | `product.options.${number}.key`
      | `product.modifiers`
      | `product.modifiers.${number}.freeTextSettings.minCharCount`
      | `product.modifiers.${number}.freeTextSettings.maxCharCount`
      | `product.modifiers.${number}.freeTextSettings.title`
      | `product.modifiers.${number}.freeTextSettings.key`
      | `product.modifiers.${number}.modifierRenderType`
      | `product.modifiers.${number}.mandatory`
      | `product.modifiers.${number}.key`
      | `product.infoSections`
      | `product.directCategoriesInfo.categories`
      | `product.directCategoriesInfo.categories.${number}._id`
      | `product.costRange.minValue.amount`
      | `product.inventory.availabilityStatus`
      | `product.inventory.preorderStatus`
      | `product.inventory.preorderAvailability`
      | `product.productType`
      | `product.breadcrumbsInfo.breadcrumbs`
      | `product.breadcrumbsInfo.breadcrumbs.${number}.categoryId`
      | `product.breadcrumbsInfo.breadcrumbs.${number}.categoryName`
      | `product.breadcrumbsInfo.breadcrumbs.${number}.categorySlug`
      | `product.variantsInfo.variants`
      | `product.variantsInfo.variants.${number}.physicalProperties.pricePerUnit.value`
      | `product.variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile.fileName`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile.fileType`
      | `product.variantsInfo.variants.${number}.revenueDetails.profitMargin`
      | `product.variantsInfo.variants.${number}.inventoryStatus.inStock`
      | `product.variantsInfo.variants.${number}.inventoryStatus.preorderEnabled`
      | `product.purchaseEligibility.userCriteria`
      | `product.additionalRibbons`
      | `product.tags.privateTags.tagIds`
      | `product.subscriptionDetails.subscriptions`
      | `product.subscriptionDetails.subscriptions.${number}.autoRenewal`
      | `product.subscriptionDetails.subscriptions.${number}.billingCycles`
      | `product.subscriptionDetails.subscriptions.${number}.title`
      | `product.subscriptionDetails.subscriptions.${number}.frequency`
      | `product.subscriptionDetails.subscriptions.${number}.discount.amountOff`
      | `product.subscriptionDetails.subscriptions.${number}.discount.percentOff`
      | `product.subscriptionDetails.subscriptions.${number}.discount.type`
      | `product.variantSummary.variantCount`
      | `inventoryResults.results`
      | `inventoryResults.results.${number}.itemMetadata.originalIndex`
      | `inventoryResults.results.${number}.itemMetadata.success`
      | `inventoryResults.results.${number}.itemMetadata.error.code`
      | `inventoryResults.results.${number}.itemMetadata.error.description`
      | `inventoryResults.results.${number}.item.inStock`
      | `inventoryResults.results.${number}.item.quantity`
      | `inventoryResults.results.${number}.item.variantId`
      | `inventoryResults.results.${number}.item.productId`
      | `inventoryResults.results.${number}.item.trackQuantity`
      | `inventoryResults.results.${number}.item.availabilityStatus`
      | `inventoryResults.bulkActionMetadata.totalSuccesses`
      | `inventoryResults.bulkActionMetadata.totalFailures`
      | `inventoryResults.bulkActionMetadata.undetailedFailures`,
      8
    > & {
      __applicationErrorsType?: UpdateProductWithInventoryApplicationErrors;
      __validationErrorsType?: UpdateProductWithInventoryValidationErrors;
    }
  >;
}

export function bulkCreateProducts(
  httpClient: HttpClient
): BulkCreateProductsSignature {
  return (
    products: NonNullablePaths<
      V3Product,
      | `modifiers.${number}.choicesSettings.choices`
      | `name`
      | `options.${number}.choicesSettings.choices`
      | `physicalProperties.pricePerUnit.measurementUnit`
      | `productType`
      | `subscriptionDetails.subscriptions`
      | `subscriptionDetails.subscriptions.${number}.discount.type`
      | `subscriptionDetails.subscriptions.${number}.frequency`
      | `subscriptionDetails.subscriptions.${number}.title`
      | `variantsInfo`
      | `variantsInfo.variants`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.choiceId`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.optionId`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `variantsInfo.variants.${number}.physicalProperties.packageDimensions.unit`
      | `variantsInfo.variants.${number}.physicalProperties.pricePerUnit.settings.measurementUnit`
      | `variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `variantsInfo.variants.${number}.price`
      | `variantsInfo.variants.${number}.price.actualPrice`,
      8
    >[],
    options?: BulkCreateProductsOptions
  ) =>
    universalBulkCreateProducts(
      products,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkCreateProductsSignature {
  /**
   * Creates up to 100 products.
   *
   * >**Note:**
   * > The following limits apply to the total number of creatable entities in a single request.
   * >
   * > + `options`: 100
   * > + `modifiers`: 100
   * > + `infoSections`: 100
   * > + `variantsInfo.variants`: 1000
   * >
   * > For example, you can create 10 products with up to 10 options for each product (10 x 10 = 100), or 1 product with 100 options.
   * > Alternatively, you can create 100 products with up to 10 variants in each (100 x 10 = 1000), or 1 product with 1000 variants.
   * @param - List of products to create.
   */
  (
    products: NonNullablePaths<
      V3Product,
      | `modifiers.${number}.choicesSettings.choices`
      | `name`
      | `options.${number}.choicesSettings.choices`
      | `physicalProperties.pricePerUnit.measurementUnit`
      | `productType`
      | `subscriptionDetails.subscriptions`
      | `subscriptionDetails.subscriptions.${number}.discount.type`
      | `subscriptionDetails.subscriptions.${number}.frequency`
      | `subscriptionDetails.subscriptions.${number}.title`
      | `variantsInfo`
      | `variantsInfo.variants`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.choiceId`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.optionId`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `variantsInfo.variants.${number}.physicalProperties.packageDimensions.unit`
      | `variantsInfo.variants.${number}.physicalProperties.pricePerUnit.settings.measurementUnit`
      | `variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `variantsInfo.variants.${number}.price`
      | `variantsInfo.variants.${number}.price.actualPrice`,
      8
    >[],
    options?: BulkCreateProductsOptions
  ): Promise<
    NonNullablePaths<
      BulkCreateProductsResponse,
      | `results`
      | `results.${number}.itemMetadata.originalIndex`
      | `results.${number}.itemMetadata.success`
      | `results.${number}.itemMetadata.error.code`
      | `results.${number}.itemMetadata.error.description`
      | `results.${number}.item.inventory.availabilityStatus`
      | `results.${number}.item.inventory.preorderStatus`
      | `results.${number}.item.inventory.preorderAvailability`
      | `results.${number}.item.productType`
      | `results.${number}.item.purchaseEligibility.userCriteria`
      | `results.${number}.item.variantSummary.variantCount`
      | `bulkActionMetadata.totalSuccesses`
      | `bulkActionMetadata.totalFailures`
      | `bulkActionMetadata.undetailedFailures`,
      6
    > & {
      __applicationErrorsType?: BulkCreateProductsApplicationErrors;
      __validationErrorsType?: BulkCreateProductsValidationErrors;
    }
  >;
}

export function bulkCreateProductsWithInventory(
  httpClient: HttpClient
): BulkCreateProductsWithInventorySignature {
  return (
    products: NonNullablePaths<
      ProductWithInventory,
      | `modifiers.${number}.choicesSettings.choices`
      | `name`
      | `options.${number}.choicesSettings.choices`
      | `physicalProperties.pricePerUnit.measurementUnit`
      | `productType`
      | `subscriptionDetails.subscriptions`
      | `subscriptionDetails.subscriptions.${number}.discount.type`
      | `subscriptionDetails.subscriptions.${number}.frequency`
      | `subscriptionDetails.subscriptions.${number}.title`
      | `variantsInfo`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.choiceId`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.optionId`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `variantsInfo.variants.${number}.physicalProperties.packageDimensions.unit`
      | `variantsInfo.variants.${number}.physicalProperties.pricePerUnit.settings.measurementUnit`
      | `variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `variantsInfo.variants.${number}.price`
      | `variantsInfo.variants.${number}.price.actualPrice`,
      8
    >[],
    options?: BulkCreateProductsWithInventoryOptions
  ) =>
    universalBulkCreateProductsWithInventory(
      products,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkCreateProductsWithInventorySignature {
  /**
   * Creates up to 100 products, and can create the products' inventories in the variants' default locations.
   *
   * >**Note:**
   * > The following limits apply to the total number of creatable entities in a single request.
   * >
   * > + `options`: 100
   * > + `modifiers`: 100
   * > + `infoSections`: 100
   * > + `variantsInfo.variants`: 1000
   * >
   * > For example, you can create 10 products with up to 10 options for each product (10 x 10 = 100), or 1 product with 100 options.
   * > Alternatively, you can create 100 products with up to 10 variants in each (100 x 10 = 1000), or 1 product with 1000 variants.
   * @param - List of products to create with inventory.
   */
  (
    products: NonNullablePaths<
      ProductWithInventory,
      | `modifiers.${number}.choicesSettings.choices`
      | `name`
      | `options.${number}.choicesSettings.choices`
      | `physicalProperties.pricePerUnit.measurementUnit`
      | `productType`
      | `subscriptionDetails.subscriptions`
      | `subscriptionDetails.subscriptions.${number}.discount.type`
      | `subscriptionDetails.subscriptions.${number}.frequency`
      | `subscriptionDetails.subscriptions.${number}.title`
      | `variantsInfo`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.choiceId`
      | `variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.optionId`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `variantsInfo.variants.${number}.physicalProperties.packageDimensions.unit`
      | `variantsInfo.variants.${number}.physicalProperties.pricePerUnit.settings.measurementUnit`
      | `variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `variantsInfo.variants.${number}.price`
      | `variantsInfo.variants.${number}.price.actualPrice`,
      8
    >[],
    options?: BulkCreateProductsWithInventoryOptions
  ): Promise<
    NonNullablePaths<
      BulkCreateProductsWithInventoryResponse,
      | `productResults.results`
      | `productResults.results.${number}.itemMetadata.originalIndex`
      | `productResults.results.${number}.itemMetadata.success`
      | `productResults.results.${number}.itemMetadata.error.code`
      | `productResults.results.${number}.itemMetadata.error.description`
      | `productResults.results.${number}.item.inventory.availabilityStatus`
      | `productResults.results.${number}.item.inventory.preorderStatus`
      | `productResults.results.${number}.item.inventory.preorderAvailability`
      | `productResults.results.${number}.item.productType`
      | `productResults.results.${number}.item.purchaseEligibility.userCriteria`
      | `productResults.results.${number}.item.variantSummary.variantCount`
      | `productResults.bulkActionMetadata.totalSuccesses`
      | `productResults.bulkActionMetadata.totalFailures`
      | `productResults.bulkActionMetadata.undetailedFailures`
      | `inventoryResults.results`
      | `inventoryResults.results.${number}.itemMetadata.originalIndex`
      | `inventoryResults.results.${number}.itemMetadata.success`
      | `inventoryResults.results.${number}.itemMetadata.error.code`
      | `inventoryResults.results.${number}.itemMetadata.error.description`
      | `inventoryResults.results.${number}.item.inStock`
      | `inventoryResults.results.${number}.item.quantity`
      | `inventoryResults.results.${number}.item.variantId`
      | `inventoryResults.results.${number}.item.productId`
      | `inventoryResults.results.${number}.item.trackQuantity`
      | `inventoryResults.results.${number}.item.availabilityStatus`
      | `inventoryResults.bulkActionMetadata.totalSuccesses`
      | `inventoryResults.bulkActionMetadata.totalFailures`
      | `inventoryResults.bulkActionMetadata.undetailedFailures`,
      7
    > & {
      __applicationErrorsType?: BulkCreateProductsWithInventoryApplicationErrors;
      __validationErrorsType?: BulkCreateProductsWithInventoryValidationErrors;
    }
  >;
}

export function bulkUpdateProducts(
  httpClient: HttpClient
): BulkUpdateProductsSignature {
  return (
    products: NonNullablePaths<
      V3MaskedProduct,
      | `product`
      | `product._id`
      | `product.modifiers.${number}.choicesSettings.choices`
      | `product.options.${number}.choicesSettings.choices`
      | `product.physicalProperties.pricePerUnit.measurementUnit`
      | `product.revision`
      | `product.subscriptionDetails.subscriptions.${number}.discount.type`
      | `product.subscriptionDetails.subscriptions.${number}.frequency`
      | `product.subscriptionDetails.subscriptions.${number}.title`
      | `product.variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.choiceId`
      | `product.variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.optionId`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `product.variantsInfo.variants.${number}.physicalProperties.packageDimensions.unit`
      | `product.variantsInfo.variants.${number}.physicalProperties.pricePerUnit.settings.measurementUnit`
      | `product.variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `product.variantsInfo.variants.${number}.price`
      | `product.variantsInfo.variants.${number}.price.actualPrice`,
      9
    >[],
    options?: BulkUpdateProductsOptions
  ) =>
    universalBulkUpdateProducts(
      products,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkUpdateProductsSignature {
  /**
   * Updates up to 100 products.
   *
   * >**Note:**
   * > The following limits apply to the total number of updatable entities in a single request.
   * > For example, you can update 10 products with up to 10 options for each product (10 x 10 = 100), or one product with 100 options.
   * > Alternatively, you can update 100 products with up to 10 variants in each (100 x 10 = 1000), or one product with 1000 variants.
   * > + `options`: 100
   * > + `modifiers`: 100
   * > + `infoSections`: 100
   * > + `variantsInfo.variants`: 1000
   * @param - List of products to update.
   */
  (
    products: NonNullablePaths<
      V3MaskedProduct,
      | `product`
      | `product._id`
      | `product.modifiers.${number}.choicesSettings.choices`
      | `product.options.${number}.choicesSettings.choices`
      | `product.physicalProperties.pricePerUnit.measurementUnit`
      | `product.revision`
      | `product.subscriptionDetails.subscriptions.${number}.discount.type`
      | `product.subscriptionDetails.subscriptions.${number}.frequency`
      | `product.subscriptionDetails.subscriptions.${number}.title`
      | `product.variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.choiceId`
      | `product.variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.optionId`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `product.variantsInfo.variants.${number}.physicalProperties.packageDimensions.unit`
      | `product.variantsInfo.variants.${number}.physicalProperties.pricePerUnit.settings.measurementUnit`
      | `product.variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `product.variantsInfo.variants.${number}.price`
      | `product.variantsInfo.variants.${number}.price.actualPrice`,
      9
    >[],
    options?: BulkUpdateProductsOptions
  ): Promise<
    NonNullablePaths<
      BulkUpdateProductsResponse,
      | `results`
      | `results.${number}.itemMetadata.originalIndex`
      | `results.${number}.itemMetadata.success`
      | `results.${number}.itemMetadata.error.code`
      | `results.${number}.itemMetadata.error.description`
      | `results.${number}.item.inventory.availabilityStatus`
      | `results.${number}.item.inventory.preorderStatus`
      | `results.${number}.item.inventory.preorderAvailability`
      | `results.${number}.item.productType`
      | `results.${number}.item.purchaseEligibility.userCriteria`
      | `results.${number}.item.variantSummary.variantCount`
      | `bulkActionMetadata.totalSuccesses`
      | `bulkActionMetadata.totalFailures`
      | `bulkActionMetadata.undetailedFailures`,
      6
    > & {
      __applicationErrorsType?: BulkUpdateProductsApplicationErrors;
      __validationErrorsType?: BulkUpdateProductsValidationErrors;
    }
  >;
}

export function bulkUpdateProductsWithInventory(
  httpClient: HttpClient
): BulkUpdateProductsWithInventorySignature {
  return (
    products: NonNullablePaths<
      MaskedProductWithInventory,
      | `product`
      | `product._id`
      | `product.modifiers.${number}.choicesSettings.choices`
      | `product.options.${number}.choicesSettings.choices`
      | `product.physicalProperties.pricePerUnit.measurementUnit`
      | `product.revision`
      | `product.subscriptionDetails.subscriptions.${number}.discount.type`
      | `product.subscriptionDetails.subscriptions.${number}.frequency`
      | `product.subscriptionDetails.subscriptions.${number}.title`
      | `product.variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.choiceId`
      | `product.variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.optionId`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `product.variantsInfo.variants.${number}.physicalProperties.packageDimensions.unit`
      | `product.variantsInfo.variants.${number}.physicalProperties.pricePerUnit.settings.measurementUnit`
      | `product.variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `product.variantsInfo.variants.${number}.price`
      | `product.variantsInfo.variants.${number}.price.actualPrice`,
      9
    >[],
    options?: BulkUpdateProductsWithInventoryOptions
  ) =>
    universalBulkUpdateProductsWithInventory(
      products,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkUpdateProductsWithInventorySignature {
  /**
   * Updates up to 100 products, and can update the products' inventories in the variants' default locations.
   *
   * >**Note:**
   * > The following limits apply to the total number of updatable entities in a single request.
   * > For example, you can update 10 products with up to 10 options for each product (10 x 10 = 100), or one product with 100 options.
   * > Alternatively, you can update 100 products with up to 10 variants in each (100 x 10 = 1000), or one product with 1000 variants.
   * > + `options`: 100
   * > + `modifiers`: 100
   * > + `infoSections`: 100
   * > + `variantsInfo.variants`: 1000
   * @param - List of products to update.
   */
  (
    products: NonNullablePaths<
      MaskedProductWithInventory,
      | `product`
      | `product._id`
      | `product.modifiers.${number}.choicesSettings.choices`
      | `product.options.${number}.choicesSettings.choices`
      | `product.physicalProperties.pricePerUnit.measurementUnit`
      | `product.revision`
      | `product.subscriptionDetails.subscriptions.${number}.discount.type`
      | `product.subscriptionDetails.subscriptions.${number}.frequency`
      | `product.subscriptionDetails.subscriptions.${number}.title`
      | `product.variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.choiceId`
      | `product.variantsInfo.variants.${number}.choices.${number}.optionChoiceIds.optionId`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `product.variantsInfo.variants.${number}.physicalProperties.packageDimensions.unit`
      | `product.variantsInfo.variants.${number}.physicalProperties.pricePerUnit.settings.measurementUnit`
      | `product.variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `product.variantsInfo.variants.${number}.price`
      | `product.variantsInfo.variants.${number}.price.actualPrice`,
      9
    >[],
    options?: BulkUpdateProductsWithInventoryOptions
  ): Promise<
    NonNullablePaths<
      BulkUpdateProductsWithInventoryResponse,
      | `productResults.results`
      | `productResults.results.${number}.itemMetadata.originalIndex`
      | `productResults.results.${number}.itemMetadata.success`
      | `productResults.results.${number}.itemMetadata.error.code`
      | `productResults.results.${number}.itemMetadata.error.description`
      | `productResults.results.${number}.item.inventory.availabilityStatus`
      | `productResults.results.${number}.item.inventory.preorderStatus`
      | `productResults.results.${number}.item.inventory.preorderAvailability`
      | `productResults.results.${number}.item.productType`
      | `productResults.results.${number}.item.purchaseEligibility.userCriteria`
      | `productResults.results.${number}.item.variantSummary.variantCount`
      | `productResults.bulkActionMetadata.totalSuccesses`
      | `productResults.bulkActionMetadata.totalFailures`
      | `productResults.bulkActionMetadata.undetailedFailures`
      | `inventoryResults.results`
      | `inventoryResults.results.${number}.itemMetadata.originalIndex`
      | `inventoryResults.results.${number}.itemMetadata.success`
      | `inventoryResults.results.${number}.itemMetadata.error.code`
      | `inventoryResults.results.${number}.itemMetadata.error.description`
      | `inventoryResults.results.${number}.item.inStock`
      | `inventoryResults.results.${number}.item.quantity`
      | `inventoryResults.results.${number}.item.variantId`
      | `inventoryResults.results.${number}.item.productId`
      | `inventoryResults.results.${number}.item.trackQuantity`
      | `inventoryResults.results.${number}.item.availabilityStatus`
      | `inventoryResults.bulkActionMetadata.totalSuccesses`
      | `inventoryResults.bulkActionMetadata.totalFailures`
      | `inventoryResults.bulkActionMetadata.undetailedFailures`,
      7
    > & {
      __applicationErrorsType?: BulkUpdateProductsWithInventoryApplicationErrors;
      __validationErrorsType?: BulkUpdateProductsWithInventoryValidationErrors;
    }
  >;
}

export function bulkUpdateProductsByFilter(
  httpClient: HttpClient
): BulkUpdateProductsByFilterSignature {
  return (
    options?: NonNullablePaths<
      BulkUpdateProductsByFilterOptions,
      | `product`
      | `product.subscriptionDetails.subscriptions.${number}.discount.type`
      | `product.subscriptionDetails.subscriptions.${number}.frequency`
      | `product.subscriptionDetails.subscriptions.${number}.title`,
      7
    >
  ) =>
    universalBulkUpdateProductsByFilter(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkUpdateProductsByFilterSignature {
  /**
   * Updates multiple products, given the provided filter.
   *
   * To update `infoSections`, `brand` or `ribbon` fields, you must also pass their existing `id`.
   *
   * > **Note:**
   * > The following fields can't be updated with this endpoint:
   * > + `slug`
   * > + `options`
   * > + `modifiers`
   * > + `variantsInfo`
   * >
   * > To update these fields, use [Bulk Update Products](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/products-v3/bulk-update-products).
   */
  (
    options?: NonNullablePaths<
      BulkUpdateProductsByFilterOptions,
      | `product`
      | `product.subscriptionDetails.subscriptions.${number}.discount.type`
      | `product.subscriptionDetails.subscriptions.${number}.frequency`
      | `product.subscriptionDetails.subscriptions.${number}.title`,
      7
    >
  ): Promise<
    NonNullablePaths<V3BulkUpdateProductsByFilterResponse, `jobId`, 2> & {
      __applicationErrorsType?: BulkUpdateProductsByFilterApplicationErrors;
      __validationErrorsType?: BulkUpdateProductsByFilterValidationErrors;
    }
  >;
}

export function deleteProduct(httpClient: HttpClient): DeleteProductSignature {
  return (productId: string) =>
    universalDeleteProduct(
      productId,
      // @ts-ignore
      { httpClient }
    );
}

interface DeleteProductSignature {
  /**
   * Deletes a product.
   * @param - Product ID.
   */
  (productId: string): Promise<void>;
}

export function bulkDeleteProducts(
  httpClient: HttpClient
): BulkDeleteProductsSignature {
  return (productIds: string[]) =>
    universalBulkDeleteProducts(
      productIds,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkDeleteProductsSignature {
  /**
   * Deletes multiple products.
   * @param - IDs of products to delete.
   */
  (productIds: string[]): Promise<
    NonNullablePaths<
      V3BulkDeleteProductsResponse,
      | `results`
      | `results.${number}.itemMetadata.originalIndex`
      | `results.${number}.itemMetadata.success`
      | `results.${number}.itemMetadata.error.code`
      | `results.${number}.itemMetadata.error.description`
      | `bulkActionMetadata.totalSuccesses`
      | `bulkActionMetadata.totalFailures`
      | `bulkActionMetadata.undetailedFailures`,
      6
    > & {
      __validationErrorsType?: BulkDeleteProductsValidationErrors;
    }
  >;
}

export function bulkDeleteProductsByFilter(
  httpClient: HttpClient
): BulkDeleteProductsByFilterSignature {
  return (
    filter: Record<string, any>,
    options?: BulkDeleteProductsByFilterOptions
  ) =>
    universalBulkDeleteProductsByFilter(
      filter,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkDeleteProductsByFilterSignature {
  /**
   * Delete multiple products given the provided filter.
   * @param - Filter object.
   */
  (
    filter: Record<string, any>,
    options?: BulkDeleteProductsByFilterOptions
  ): Promise<
    NonNullablePaths<V3BulkDeleteProductsByFilterResponse, `jobId`, 2>
  >;
}

export function getProduct(httpClient: HttpClient): GetProductSignature {
  return (productId: string, options?: GetProductOptions) =>
    universalGetProduct(
      productId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetProductSignature {
  /**
   * Retrieves a product.
   *
   * > **Note:**
   * > To retrieve a non-visible product (`visible: false`), your app must have the 'Product v3 read admin' (`SCOPE.STORES.PRODUCT_READ_ADMIN`) permission scope.
   * @param - Product ID.
   * @returns Product.
   */
  (productId: string, options?: GetProductOptions): Promise<
    NonNullablePaths<
      V3Product,
      | `physicalProperties.pricePerUnit.quantity`
      | `physicalProperties.pricePerUnit.measurementUnit`
      | `physicalProperties.shippingWeightRange.minValue`
      | `physicalProperties.shippingWeightRange.maxValue`
      | `physicalProperties.pricePerUnitRange.minValue.value`
      | `physicalProperties.weightMeasurementUnitInfo.weightMeasurementUnit`
      | `media.main._id`
      | `media.main.url`
      | `media.main.mediaType`
      | `media.main.thumbnail.url`
      | `media.main.thumbnail.height`
      | `media.main.thumbnail.width`
      | `media.main.uploadId`
      | `media.itemsInfo.items`
      | `seoData.tags`
      | `seoData.tags.${number}.type`
      | `seoData.tags.${number}.children`
      | `seoData.tags.${number}.custom`
      | `seoData.tags.${number}.disabled`
      | `seoData.settings.preventAutoRedirect`
      | `seoData.settings.keywords`
      | `seoData.settings.keywords.${number}.term`
      | `seoData.settings.keywords.${number}.isMain`
      | `options`
      | `options.${number}.optionRenderType`
      | `options.${number}.key`
      | `modifiers`
      | `modifiers.${number}.freeTextSettings.minCharCount`
      | `modifiers.${number}.freeTextSettings.maxCharCount`
      | `modifiers.${number}.freeTextSettings.title`
      | `modifiers.${number}.freeTextSettings.key`
      | `modifiers.${number}.modifierRenderType`
      | `modifiers.${number}.mandatory`
      | `modifiers.${number}.key`
      | `infoSections`
      | `directCategoriesInfo.categories`
      | `directCategoriesInfo.categories.${number}._id`
      | `costRange.minValue.amount`
      | `inventory.availabilityStatus`
      | `inventory.preorderStatus`
      | `inventory.preorderAvailability`
      | `productType`
      | `breadcrumbsInfo.breadcrumbs`
      | `breadcrumbsInfo.breadcrumbs.${number}.categoryId`
      | `breadcrumbsInfo.breadcrumbs.${number}.categoryName`
      | `breadcrumbsInfo.breadcrumbs.${number}.categorySlug`
      | `variantsInfo.variants`
      | `variantsInfo.variants.${number}.physicalProperties.pricePerUnit.value`
      | `variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile.fileName`
      | `variantsInfo.variants.${number}.digitalProperties.digitalFile.fileType`
      | `variantsInfo.variants.${number}.revenueDetails.profitMargin`
      | `variantsInfo.variants.${number}.inventoryStatus.inStock`
      | `variantsInfo.variants.${number}.inventoryStatus.preorderEnabled`
      | `purchaseEligibility.userCriteria`
      | `additionalRibbons`
      | `tags.privateTags.tagIds`
      | `subscriptionDetails.subscriptions`
      | `subscriptionDetails.subscriptions.${number}.autoRenewal`
      | `subscriptionDetails.subscriptions.${number}.billingCycles`
      | `subscriptionDetails.subscriptions.${number}.title`
      | `subscriptionDetails.subscriptions.${number}.frequency`
      | `subscriptionDetails.subscriptions.${number}.discount.amountOff`
      | `subscriptionDetails.subscriptions.${number}.discount.percentOff`
      | `subscriptionDetails.subscriptions.${number}.discount.type`
      | `variantSummary.variantCount`,
      7
    > & {
      __applicationErrorsType?: GetProductApplicationErrors;
    }
  >;
}

export function getProductBySlug(
  httpClient: HttpClient
): GetProductBySlugSignature {
  return (slug: string, options?: GetProductBySlugOptions) =>
    universalGetProductBySlug(
      slug,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetProductBySlugSignature {
  /**
   * Retrieves a product by slug.
   *
   * > **Note:**
   * > To retrieve a non-visible product (`visible: false`), your app must have the 'Product v3 read admin' (`SCOPE.STORES.PRODUCT_READ_ADMIN`) permission scope.
   * @param - Product slug.
   */
  (slug: string, options?: GetProductBySlugOptions): Promise<
    NonNullablePaths<
      V3GetProductBySlugResponse,
      | `product.physicalProperties.pricePerUnit.quantity`
      | `product.physicalProperties.pricePerUnit.measurementUnit`
      | `product.physicalProperties.shippingWeightRange.minValue`
      | `product.physicalProperties.shippingWeightRange.maxValue`
      | `product.physicalProperties.pricePerUnitRange.minValue.value`
      | `product.physicalProperties.weightMeasurementUnitInfo.weightMeasurementUnit`
      | `product.media.main._id`
      | `product.media.main.url`
      | `product.media.main.mediaType`
      | `product.media.main.thumbnail.url`
      | `product.media.main.thumbnail.height`
      | `product.media.main.thumbnail.width`
      | `product.media.main.uploadId`
      | `product.media.itemsInfo.items`
      | `product.seoData.tags`
      | `product.seoData.tags.${number}.type`
      | `product.seoData.tags.${number}.children`
      | `product.seoData.tags.${number}.custom`
      | `product.seoData.tags.${number}.disabled`
      | `product.seoData.settings.preventAutoRedirect`
      | `product.seoData.settings.keywords`
      | `product.seoData.settings.keywords.${number}.term`
      | `product.seoData.settings.keywords.${number}.isMain`
      | `product.options`
      | `product.options.${number}.optionRenderType`
      | `product.options.${number}.key`
      | `product.modifiers`
      | `product.modifiers.${number}.freeTextSettings.minCharCount`
      | `product.modifiers.${number}.freeTextSettings.maxCharCount`
      | `product.modifiers.${number}.freeTextSettings.title`
      | `product.modifiers.${number}.freeTextSettings.key`
      | `product.modifiers.${number}.modifierRenderType`
      | `product.modifiers.${number}.mandatory`
      | `product.modifiers.${number}.key`
      | `product.infoSections`
      | `product.directCategoriesInfo.categories`
      | `product.directCategoriesInfo.categories.${number}._id`
      | `product.costRange.minValue.amount`
      | `product.inventory.availabilityStatus`
      | `product.inventory.preorderStatus`
      | `product.inventory.preorderAvailability`
      | `product.productType`
      | `product.breadcrumbsInfo.breadcrumbs`
      | `product.breadcrumbsInfo.breadcrumbs.${number}.categoryId`
      | `product.breadcrumbsInfo.breadcrumbs.${number}.categoryName`
      | `product.breadcrumbsInfo.breadcrumbs.${number}.categorySlug`
      | `product.variantsInfo.variants`
      | `product.variantsInfo.variants.${number}.physicalProperties.pricePerUnit.value`
      | `product.variantsInfo.variants.${number}.physicalProperties.productDimensions.unit`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile._id`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile.fileName`
      | `product.variantsInfo.variants.${number}.digitalProperties.digitalFile.fileType`
      | `product.variantsInfo.variants.${number}.revenueDetails.profitMargin`
      | `product.variantsInfo.variants.${number}.inventoryStatus.inStock`
      | `product.variantsInfo.variants.${number}.inventoryStatus.preorderEnabled`
      | `product.purchaseEligibility.userCriteria`
      | `product.additionalRibbons`
      | `product.tags.privateTags.tagIds`
      | `product.subscriptionDetails.subscriptions`
      | `product.subscriptionDetails.subscriptions.${number}.autoRenewal`
      | `product.subscriptionDetails.subscriptions.${number}.billingCycles`
      | `product.subscriptionDetails.subscriptions.${number}.title`
      | `product.subscriptionDetails.subscriptions.${number}.frequency`
      | `product.subscriptionDetails.subscriptions.${number}.discount.amountOff`
      | `product.subscriptionDetails.subscriptions.${number}.discount.percentOff`
      | `product.subscriptionDetails.subscriptions.${number}.discount.type`
      | `product.variantSummary.variantCount`,
      8
    > & {
      __applicationErrorsType?: GetProductBySlugApplicationErrors;
    }
  >;
}

export function searchProducts(
  httpClient: HttpClient
): SearchProductsSignature {
  return (search: V3ProductSearch, options?: SearchProductsOptions) =>
    universalSearchProducts(
      search,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface SearchProductsSignature {
  /**
   * Retrieves a list of up to 100 products, given the provided filtering, search expression, sorting, and cursor paging.
   * Pass supported values to the `fields` array in the request to include those fields in the response.
   *
   * To learn about working with _Search_ endpoints, see
   * [API Query Language](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language),
   * and [Sorting and Paging](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-sorting-and-paging).
   *
   * Learn more about the differences between [_Query_ and _Search_](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-search-query-and-list-methods) methods.
   *
   * > **Notes:**
   * > + When using free-text search, you must specify which fields to search using the `search.fields` parameter.
   * > + To retrieve a non-visible product (`visible: false`), your app must have the 'Product v3 read admin' (`SCOPE.STORES.PRODUCT_READ_ADMIN`) permission scope.
   * > + This method does not return variant data. To retrieve variant data, call [Get Product](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/products-v3/get-product) or [Get Product By Slug](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/products-v3/get-product-by-slug) for each product individually, or use the [Read-Only Variants API](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/read-only-variants-v3/introduction) for variant-centric queries.
   * @param - Search options.
   */
  (search: V3ProductSearch, options?: SearchProductsOptions): Promise<
    NonNullablePaths<
      V3SearchProductsResponse,
      | `products`
      | `products.${number}.physicalProperties.pricePerUnit.quantity`
      | `products.${number}.physicalProperties.pricePerUnit.measurementUnit`
      | `products.${number}.physicalProperties.shippingWeightRange.minValue`
      | `products.${number}.physicalProperties.shippingWeightRange.maxValue`
      | `products.${number}.physicalProperties.weightMeasurementUnitInfo.weightMeasurementUnit`
      | `products.${number}.media.main._id`
      | `products.${number}.media.main.url`
      | `products.${number}.media.main.mediaType`
      | `products.${number}.media.main.uploadId`
      | `products.${number}.seoData.settings.preventAutoRedirect`
      | `products.${number}.costRange.minValue.amount`
      | `products.${number}.inventory.availabilityStatus`
      | `products.${number}.inventory.preorderStatus`
      | `products.${number}.inventory.preorderAvailability`
      | `products.${number}.productType`
      | `products.${number}.purchaseEligibility.userCriteria`
      | `products.${number}.variantSummary.variantCount`
      | `aggregationData.results`
      | `aggregationData.results.${number}.scalar.type`
      | `aggregationData.results.${number}.scalar.value`
      | `aggregationData.results.${number}.name`
      | `aggregationData.results.${number}.type`
      | `aggregationData.results.${number}.fieldPath`,
      6
    > & {
      __applicationErrorsType?: SearchProductsApplicationErrors;
    }
  >;
}

export function queryProducts(httpClient: HttpClient): QueryProductsSignature {
  return (options?: QueryProductsOptions) =>
    universalQueryProducts(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface QueryProductsSignature {
  /**
   * Retrieves a list of up to 100 products, given the provided filtering, sorting, and cursor paging.
   * Pass supported values to the `fields` array in the request to include those fields in the response.
   *
   * To learn about working with _Query_ endpoints, see
   * [API Query Language](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language),
   * and [Sorting and Paging](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-sorting-and-paging).
   *
   * Learn more about the differences between [_Query_ and _Search_](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-search-query-and-list-methods) methods.
   *
   * > **Notes:**
   * > + To retrieve a non-visible product (`visible: false`), your app must have the 'Product v3 read admin' (`SCOPE.STORES.PRODUCT_READ_ADMIN`) permission scope.
   * > + This method does not return variant data. To retrieve variant data, call [Get Product](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/products-v3/get-product) or [Get Product By Slug](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/products-v3/get-product-by-slug) for each product individually, or use the [Read-Only Variants API](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/read-only-variants-v3/introduction) for variant-centric queries.
   *
   * > **Note:** Query Products supports a narrow set of filterable and sortable fields. Unsupported fields return a `Field '<fieldName>' is not declared as filterable` error. To look up products by name or brand, call [Search Products](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/products-v3/search-products) instead. For the full list of supported fields and per-field operators, see [Supported Filters and Sorting](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/products-v3/supported-filters-and-sorting).
   */
  (options?: QueryProductsOptions): ProductsQueryBuilder;
}

export function typedQueryProducts(
  httpClient: HttpClient
): TypedQueryProductsSignature {
  return (query: V3ProductQuery, options?: QueryProductsOptions) =>
    universalTypedQueryProducts(
      query,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface TypedQueryProductsSignature {
  /** */
  (query: V3ProductQuery, options?: QueryProductsOptions): Promise<
    NonNullablePaths<
      V3QueryProductsResponse,
      | `products`
      | `products.${number}.physicalProperties.pricePerUnit.quantity`
      | `products.${number}.physicalProperties.pricePerUnit.measurementUnit`
      | `products.${number}.physicalProperties.shippingWeightRange.minValue`
      | `products.${number}.physicalProperties.shippingWeightRange.maxValue`
      | `products.${number}.physicalProperties.weightMeasurementUnitInfo.weightMeasurementUnit`
      | `products.${number}.media.main._id`
      | `products.${number}.media.main.url`
      | `products.${number}.media.main.mediaType`
      | `products.${number}.media.main.uploadId`
      | `products.${number}.seoData.settings.preventAutoRedirect`
      | `products.${number}.costRange.minValue.amount`
      | `products.${number}.inventory.availabilityStatus`
      | `products.${number}.inventory.preorderStatus`
      | `products.${number}.inventory.preorderAvailability`
      | `products.${number}.productType`
      | `products.${number}.purchaseEligibility.userCriteria`
      | `products.${number}.variantSummary.variantCount`,
      6
    > & {
      __applicationErrorsType?: QueryProductsApplicationErrors;
    }
  >;
}

export function countProducts(httpClient: HttpClient): CountProductsSignature {
  return (options?: CountProductsOptions) =>
    universalCountProducts(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface CountProductsSignature {
  /**
   * Counts the number of products that match the provided filtering.
   */
  (options?: CountProductsOptions): Promise<
    NonNullablePaths<V3CountProductsResponse, `count`, 2> & {
      __applicationErrorsType?: CountProductsApplicationErrors;
    }
  >;
}

export function bulkUpdateProductVariantsByFilter(
  httpClient: HttpClient
): BulkUpdateProductVariantsByFilterSignature {
  return (
    filter: Record<string, any>,
    options?: NonNullablePaths<
      BulkUpdateProductVariantsByFilterOptions,
      `variant`,
      2
    >
  ) =>
    universalBulkUpdateProductVariantsByFilter(
      filter,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkUpdateProductVariantsByFilterSignature {
  /**
   * Updates multiple product variants, given the provided filter and search expression.
   *
   * Only the following variant fields can be updated:
   * + `visible`
   * + `price`
   * + `revenueDetails.cost`
   * + `physicalProperties`
   * @param - Filter object.
   */
  (
    filter: Record<string, any>,
    options?: NonNullablePaths<
      BulkUpdateProductVariantsByFilterOptions,
      `variant`,
      2
    >
  ): Promise<
    NonNullablePaths<BulkUpdateProductVariantsByFilterResponse, `jobId`, 2> & {
      __applicationErrorsType?: BulkUpdateProductVariantsByFilterApplicationErrors;
      __validationErrorsType?: BulkUpdateProductVariantsByFilterValidationErrors;
    }
  >;
}

export function bulkAdjustProductVariantsByFilter(
  httpClient: HttpClient
): BulkAdjustProductVariantsByFilterSignature {
  return (
    filter: Record<string, any>,
    options?: BulkAdjustProductVariantsByFilterOptions
  ) =>
    universalBulkAdjustProductVariantsByFilter(
      filter,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkAdjustProductVariantsByFilterSignature {
  /**
   * Adjusts the prices and costs of multiple variants by a specified amount or percentage, given the provided filter and search expression.
   *
   * Use this method to apply bulk pricing changes, such as increasing all prices by 10%, without setting explicit values. Use [Bulk Update Product Variants By Filter](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/products-v3/bulk-update-product-variants-by-filter) to set explicit values instead.
   *
   * The following variant fields can be increased or decreased:
   * + `compareAtPrice` - Original price before discounts
   * + `actualPrice` - Current selling price
   * + `cost` - Merchant's cost to acquire/produce the item
   * + `compareAtPriceDiscount` - Discount percentage applied to compare-at price
   * @param - Filter object.
   */
  (
    filter: Record<string, any>,
    options?: BulkAdjustProductVariantsByFilterOptions
  ): Promise<
    NonNullablePaths<
      V3BulkAdjustProductVariantsByFilterResponse,
      `jobId`,
      2
    > & {
      __applicationErrorsType?: BulkAdjustProductVariantsByFilterApplicationErrors;
      __validationErrorsType?: BulkAdjustProductVariantsByFilterValidationErrors;
    }
  >;
}

export function bulkAddInfoSectionsToProductsByFilter(
  httpClient: HttpClient
): BulkAddInfoSectionsToProductsByFilterSignature {
  return (
    filter: Record<string, any>,
    options?: NonNullablePaths<
      BulkAddInfoSectionsToProductsByFilterOptions,
      `infoSectionIds`,
      2
    >
  ) =>
    universalBulkAddInfoSectionsToProductsByFilter(
      filter,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkAddInfoSectionsToProductsByFilterSignature {
  /**
   * Adds [info sections](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/info-sections-v3/introduction) to multiple products, given the provided filter and search expression.
   * @param - Filter object.
   */
  (
    filter: Record<string, any>,
    options?: NonNullablePaths<
      BulkAddInfoSectionsToProductsByFilterOptions,
      `infoSectionIds`,
      2
    >
  ): Promise<
    NonNullablePaths<
      V3BulkAddInfoSectionsToProductsByFilterResponse,
      `jobId`,
      2
    > & {
      __applicationErrorsType?: BulkAddInfoSectionsToProductsByFilterApplicationErrors;
    }
  >;
}

export function bulkAddInfoSectionsToProducts(
  httpClient: HttpClient
): BulkAddInfoSectionsToProductsSignature {
  return (
    products: V3ProductIdWithRevision[],
    options?: NonNullablePaths<
      BulkAddInfoSectionsToProductsOptions,
      `infoSectionIds`,
      2
    >
  ) =>
    universalBulkAddInfoSectionsToProducts(
      products,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkAddInfoSectionsToProductsSignature {
  /**
   * Adds [info sections](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/info-sections-v3/introduction) to multiple products.
   * @param - List of product IDs and revisions.
   */
  (
    products: V3ProductIdWithRevision[],
    options?: NonNullablePaths<
      BulkAddInfoSectionsToProductsOptions,
      `infoSectionIds`,
      2
    >
  ): Promise<
    NonNullablePaths<
      V3BulkAddInfoSectionsToProductsResponse,
      | `results`
      | `results.${number}.itemMetadata.originalIndex`
      | `results.${number}.itemMetadata.success`
      | `results.${number}.itemMetadata.error.code`
      | `results.${number}.itemMetadata.error.description`
      | `results.${number}.item.inventory.availabilityStatus`
      | `results.${number}.item.inventory.preorderStatus`
      | `results.${number}.item.inventory.preorderAvailability`
      | `results.${number}.item.productType`
      | `results.${number}.item.purchaseEligibility.userCriteria`
      | `results.${number}.item.variantSummary.variantCount`
      | `bulkActionMetadata.totalSuccesses`
      | `bulkActionMetadata.totalFailures`
      | `bulkActionMetadata.undetailedFailures`,
      6
    > & {
      __applicationErrorsType?: BulkAddInfoSectionsToProductsApplicationErrors;
    }
  >;
}

export function bulkRemoveInfoSectionsFromProductsByFilter(
  httpClient: HttpClient
): BulkRemoveInfoSectionsFromProductsByFilterSignature {
  return (
    filter: Record<string, any>,
    options?: NonNullablePaths<
      BulkRemoveInfoSectionsFromProductsByFilterOptions,
      `infoSectionIds`,
      2
    >
  ) =>
    universalBulkRemoveInfoSectionsFromProductsByFilter(
      filter,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkRemoveInfoSectionsFromProductsByFilterSignature {
  /**
   * Removes [info sections](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/info-sections-v3/introduction) from multiple products, given the provided filter and search expression.
   * @param - Filter object.
   */
  (
    filter: Record<string, any>,
    options?: NonNullablePaths<
      BulkRemoveInfoSectionsFromProductsByFilterOptions,
      `infoSectionIds`,
      2
    >
  ): Promise<
    NonNullablePaths<
      V3BulkRemoveInfoSectionsFromProductsByFilterResponse,
      `jobId`,
      2
    >
  >;
}

export function bulkRemoveInfoSectionsFromProducts(
  httpClient: HttpClient
): BulkRemoveInfoSectionsFromProductsSignature {
  return (
    products: V3ProductIdWithRevision[],
    options?: NonNullablePaths<
      BulkRemoveInfoSectionsFromProductsOptions,
      `infoSectionIds`,
      2
    >
  ) =>
    universalBulkRemoveInfoSectionsFromProducts(
      products,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkRemoveInfoSectionsFromProductsSignature {
  /**
   * Removes [info sections](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/info-sections-v3/introduction) from multiple products.
   * @param - List of product IDs and revisions.
   */
  (
    products: V3ProductIdWithRevision[],
    options?: NonNullablePaths<
      BulkRemoveInfoSectionsFromProductsOptions,
      `infoSectionIds`,
      2
    >
  ): Promise<
    NonNullablePaths<
      V3BulkRemoveInfoSectionsFromProductsResponse,
      | `results`
      | `results.${number}.itemMetadata.originalIndex`
      | `results.${number}.itemMetadata.success`
      | `results.${number}.itemMetadata.error.code`
      | `results.${number}.itemMetadata.error.description`
      | `results.${number}.item.inventory.availabilityStatus`
      | `results.${number}.item.inventory.preorderStatus`
      | `results.${number}.item.inventory.preorderAvailability`
      | `results.${number}.item.productType`
      | `results.${number}.item.purchaseEligibility.userCriteria`
      | `results.${number}.item.variantSummary.variantCount`
      | `bulkActionMetadata.totalSuccesses`
      | `bulkActionMetadata.totalFailures`
      | `bulkActionMetadata.undetailedFailures`,
      6
    >
  >;
}

export function bulkAddProductsToCategoriesByFilter(
  httpClient: HttpClient
): BulkAddProductsToCategoriesByFilterSignature {
  return (
    options?: NonNullablePaths<
      BulkAddProductsToCategoriesByFilterOptions,
      `categoryIds`,
      2
    >
  ) =>
    universalBulkAddProductsToCategoriesByFilter(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkAddProductsToCategoriesByFilterSignature {
  /**
   * Adds multiple products to up to 5 categories, given the provided filter and search expression.
   *
   * Learn more about the [Categories API](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/categories/introduction).
   */
  (
    options?: NonNullablePaths<
      BulkAddProductsToCategoriesByFilterOptions,
      `categoryIds`,
      2
    >
  ): Promise<
    NonNullablePaths<BulkAddProductsToCategoriesByFilterResponse, `jobId`, 2>
  >;
}

export function bulkRemoveProductsFromCategoriesByFilter(
  httpClient: HttpClient
): BulkRemoveProductsFromCategoriesByFilterSignature {
  return (
    options?: NonNullablePaths<
      BulkRemoveProductsFromCategoriesByFilterOptions,
      `categoryIds`,
      2
    >
  ) =>
    universalBulkRemoveProductsFromCategoriesByFilter(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkRemoveProductsFromCategoriesByFilterSignature {
  /**
   * Removes multiple products, given the provided filter and search expression, from up to 5 categories.
   *
   * Learn more about the [Categories API](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/categories/introduction).
   */
  (
    options?: NonNullablePaths<
      BulkRemoveProductsFromCategoriesByFilterOptions,
      `categoryIds`,
      2
    >
  ): Promise<
    NonNullablePaths<
      BulkRemoveProductsFromCategoriesByFilterResponse,
      `jobId`,
      2
    >
  >;
}

export function getAllProductsCategory(
  httpClient: HttpClient
): GetAllProductsCategorySignature {
  return () =>
    universalGetAllProductsCategory(
      // @ts-ignore
      { httpClient }
    );
}

interface GetAllProductsCategorySignature {
  /**
   * Retrieves the ID of the "All Products" category, which is automatically assigned to all products.
   *
   * Learn more about the [Categories API](https://dev.wix.com/docs/api-reference/business-solutions/stores/catalog-v3/categories/introduction).
   */
  (): Promise<
    NonNullablePaths<
      GetAllProductsCategoryResponse,
      `categoryId` | `treeReference.appNamespace`,
      3
    >
  >;
}

export function bulkUpdateProductTags(
  httpClient: HttpClient
): BulkUpdateProductTagsSignature {
  return (productIds: string[], options?: BulkUpdateProductTagsOptions) =>
    universalBulkUpdateProductTags(
      productIds,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkUpdateProductTagsSignature {
  /**
   * Synchronously update tags on multiple products, by list of product IDs.
   *
   * > **Note:** If the same tag is passed to both the `assignTags` and `unassignTags` fields, it will be assigned.
   * @param - List of product IDs whose tags will be updated.
   */
  (productIds: string[], options?: BulkUpdateProductTagsOptions): Promise<
    NonNullablePaths<
      V3BulkUpdateProductTagsResponse,
      | `results`
      | `results.${number}.itemMetadata.originalIndex`
      | `results.${number}.itemMetadata.success`
      | `results.${number}.itemMetadata.error.code`
      | `results.${number}.itemMetadata.error.description`
      | `bulkActionMetadata.totalSuccesses`
      | `bulkActionMetadata.totalFailures`
      | `bulkActionMetadata.undetailedFailures`,
      6
    > & {
      __applicationErrorsType?: BulkUpdateProductTagsApplicationErrors;
    }
  >;
}

export function bulkUpdateProductTagsByFilter(
  httpClient: HttpClient
): BulkUpdateProductTagsByFilterSignature {
  return (
    filter: Record<string, any>,
    options?: BulkUpdateProductTagsByFilterOptions
  ) =>
    universalBulkUpdateProductTagsByFilter(
      filter,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkUpdateProductTagsByFilterSignature {
  /**
   * Asynchronously update tags on multiple products, by provided filter.
   * An empty filter will update all products.
   *
   * > **Note:** If the same tag is passed to both the `assignTags` and `unassignTags` fields, it will be assigned.
   * @param - Filter object. Pass an empty object `{}` to target all products.
   */
  (
    filter: Record<string, any>,
    options?: BulkUpdateProductTagsByFilterOptions
  ): Promise<
    NonNullablePaths<V3BulkUpdateProductTagsByFilterResponse, `jobId`, 2> & {
      __applicationErrorsType?: BulkUpdateProductTagsByFilterApplicationErrors;
    }
  >;
}

export const onProductCreated = EventDefinition(
  'wix.stores.catalog.v3.product_created',
  true,
  (event: ProductCreatedEnvelope) =>
    renameKeysFromRESTResponseToSDKResponse(
      transformPaths(event, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'entity.description.metadata.createdTimestamp' },
            { path: 'entity.description.metadata.updatedTimestamp' },
            {
              path: 'entity.infoSections.description.metadata.createdTimestamp',
            },
            {
              path: 'entity.infoSections.description.metadata.updatedTimestamp',
            },
            { path: 'metadata.eventTime' },
          ],
        },
        {
          transformFn: transformRESTPageURLV2ToSDKPageURLV2,
          paths: [{ path: 'entity.url' }],
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: 'entity.physicalProperties.pricePerUnit.quantity' },
            { path: 'entity.physicalProperties.shippingWeightRange.minValue' },
            { path: 'entity.physicalProperties.shippingWeightRange.maxValue' },
            {
              path: 'entity.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity',
            },
            {
              path: 'entity.variantsInfo.variants.revenueDetails.profitMargin',
            },
            {
              path: 'entity.subscriptionDetails.subscriptions.discount.percentOff',
            },
            {
              path: 'entity.variantSummary.minPriceVariant.physicalProperties.pricePerUnit.settings.quantity',
            },
            {
              path: 'entity.variantSummary.minPriceVariant.revenueDetails.profitMargin',
            },
            {
              path: 'entity.minVariantPriceInfo.pricePerUnitData.settings.quantity',
            },
            { path: 'entity.minVariantPriceInfo.revenueDetails.profitMargin' },
            {
              path: 'entity.description.nodes.buttonData.styles.background.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.buttonData.styles.background.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.buttonData.styles.background.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.buttonData.styles.backgroundHover.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.buttonData.styles.backgroundHover.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.galleryData.items.image.media.duration',
            },
            {
              path: 'entity.description.nodes.galleryData.items.video.media.duration',
            },
            {
              path: 'entity.description.nodes.galleryData.items.video.thumbnail.duration',
            },
            { path: 'entity.description.nodes.galleryData.options.item.ratio' },
            { path: 'entity.description.nodes.imageData.image.duration' },
            { path: 'entity.description.nodes.imageData.crop.x' },
            { path: 'entity.description.nodes.imageData.crop.y' },
            { path: 'entity.description.nodes.imageData.crop.width' },
            { path: 'entity.description.nodes.imageData.crop.height' },
            { path: 'entity.description.nodes.mapData.mapSettings.lat' },
            { path: 'entity.description.nodes.mapData.mapSettings.lng' },
            { path: 'entity.description.nodes.pollData.poll.image.duration' },
            {
              path: 'entity.description.nodes.pollData.poll.options.image.duration',
            },
            {
              path: 'entity.description.nodes.pollData.design.poll.background.image.duration',
            },
            { path: 'entity.description.nodes.appEmbedData.image.duration' },
            { path: 'entity.description.nodes.videoData.video.duration' },
            { path: 'entity.description.nodes.videoData.thumbnail.duration' },
            { path: 'entity.description.nodes.audioData.audio.duration' },
            { path: 'entity.description.nodes.audioData.coverImage.duration' },
            {
              path: 'entity.description.nodes.layoutData.backgroundImage.media.duration',
            },
            {
              path: 'entity.description.nodes.layoutData.backgroundImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.layoutData.backgroundImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.layoutData.backgroundImage.overlay.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.layoutData.backdropImage.media.duration',
            },
            {
              path: 'entity.description.nodes.layoutData.backdropImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.layoutData.backdropImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.layoutData.backdropImage.overlay.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.layoutData.background.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.layoutData.background.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.layoutData.background.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.layoutData.backdrop.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.layoutData.backdrop.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.layoutData.backdrop.gradient.stops.position',
            },
            { path: 'entity.description.nodes.shapeData.shape.duration' },
            {
              path: 'entity.description.nodes.cardData.background.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.cardData.background.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.cardData.background.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.cardData.backgroundImage.media.duration',
            },
            {
              path: 'entity.description.nodes.cardData.backgroundImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.cardData.backgroundImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.cardData.backgroundImage.overlay.gradient.stops.position',
            },
            { path: 'entity.description.nodes.tocData.fontSize' },
            { path: 'entity.description.nodes.tocData.itemSpacing' },
            {
              path: 'entity.description.nodes.smartBlockCellData.shape.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.background.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.background.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.background.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.backgroundHover.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.backgroundHover.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.galleryData.items.image.media.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.galleryData.items.video.media.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.galleryData.items.video.thumbnail.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.galleryData.options.item.ratio',
            },
            {
              path: 'entity.infoSections.description.nodes.imageData.image.duration',
            },
            { path: 'entity.infoSections.description.nodes.imageData.crop.x' },
            { path: 'entity.infoSections.description.nodes.imageData.crop.y' },
            {
              path: 'entity.infoSections.description.nodes.imageData.crop.width',
            },
            {
              path: 'entity.infoSections.description.nodes.imageData.crop.height',
            },
            {
              path: 'entity.infoSections.description.nodes.mapData.mapSettings.lat',
            },
            {
              path: 'entity.infoSections.description.nodes.mapData.mapSettings.lng',
            },
            {
              path: 'entity.infoSections.description.nodes.pollData.poll.image.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.pollData.poll.options.image.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.pollData.design.poll.background.image.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.appEmbedData.image.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.videoData.video.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.videoData.thumbnail.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.audioData.audio.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.audioData.coverImage.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backgroundImage.media.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backgroundImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backgroundImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backgroundImage.overlay.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdropImage.media.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdropImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdropImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdropImage.overlay.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.background.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.background.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.background.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdrop.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdrop.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdrop.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.shapeData.shape.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.background.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.background.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.background.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.backgroundImage.media.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.backgroundImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.backgroundImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.backgroundImage.overlay.gradient.stops.position',
            },
            { path: 'entity.infoSections.description.nodes.tocData.fontSize' },
            {
              path: 'entity.infoSections.description.nodes.tocData.itemSpacing',
            },
            {
              path: 'entity.infoSections.description.nodes.smartBlockCellData.shape.duration',
            },
            { path: 'entity.variantsInfo.variants.physicalProperties.weight' },
            {
              path: 'entity.variantSummary.minPriceVariant.physicalProperties.weight',
            },
            { path: 'entity.minVariantPriceInfo.weight' },
          ],
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [
            { path: 'entity.media.main.image' },
            { path: 'entity.media.itemsInfo.items.image' },
            { path: 'entity.options.choicesSettings.choices.image' },
            { path: 'entity.options.choicesSettings.choices.displayImage' },
            {
              path: 'entity.options.choicesSettings.choices.linkedMedia.image',
            },
            { path: 'entity.modifiers.choicesSettings.choices.image' },
            { path: 'entity.modifiers.choicesSettings.choices.displayImage' },
            {
              path: 'entity.modifiers.choicesSettings.choices.linkedMedia.image',
            },
            { path: 'entity.variantsInfo.variants.media.image' },
            { path: 'entity.variantSummary.minPriceVariant.media.image' },
          ],
        },
        {
          transformFn: transformRESTVideoV2ToSDKVideoV2,
          paths: [
            { path: 'entity.media.main.video' },
            { path: 'entity.media.itemsInfo.items.video' },
            {
              path: 'entity.options.choicesSettings.choices.linkedMedia.video',
            },
            {
              path: 'entity.modifiers.choicesSettings.choices.linkedMedia.video',
            },
            { path: 'entity.variantsInfo.variants.media.video' },
            { path: 'entity.variantSummary.minPriceVariant.media.video' },
          ],
        },
      ])
    )
)<ProductCreatedEnvelope>();
export const onProductDeleted = EventDefinition(
  'wix.stores.catalog.v3.product_deleted',
  true,
  (event: ProductDeletedEnvelope) =>
    renameKeysFromRESTResponseToSDKResponse(
      transformPaths(event, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'entity.description.metadata.createdTimestamp' },
            { path: 'entity.description.metadata.updatedTimestamp' },
            {
              path: 'entity.infoSections.description.metadata.createdTimestamp',
            },
            {
              path: 'entity.infoSections.description.metadata.updatedTimestamp',
            },
            { path: 'metadata.eventTime' },
          ],
        },
        {
          transformFn: transformRESTPageURLV2ToSDKPageURLV2,
          paths: [{ path: 'entity.url' }],
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: 'entity.physicalProperties.pricePerUnit.quantity' },
            { path: 'entity.physicalProperties.shippingWeightRange.minValue' },
            { path: 'entity.physicalProperties.shippingWeightRange.maxValue' },
            {
              path: 'entity.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity',
            },
            {
              path: 'entity.variantsInfo.variants.revenueDetails.profitMargin',
            },
            {
              path: 'entity.subscriptionDetails.subscriptions.discount.percentOff',
            },
            {
              path: 'entity.variantSummary.minPriceVariant.physicalProperties.pricePerUnit.settings.quantity',
            },
            {
              path: 'entity.variantSummary.minPriceVariant.revenueDetails.profitMargin',
            },
            {
              path: 'entity.minVariantPriceInfo.pricePerUnitData.settings.quantity',
            },
            { path: 'entity.minVariantPriceInfo.revenueDetails.profitMargin' },
            {
              path: 'entity.description.nodes.buttonData.styles.background.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.buttonData.styles.background.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.buttonData.styles.background.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.buttonData.styles.backgroundHover.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.buttonData.styles.backgroundHover.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.galleryData.items.image.media.duration',
            },
            {
              path: 'entity.description.nodes.galleryData.items.video.media.duration',
            },
            {
              path: 'entity.description.nodes.galleryData.items.video.thumbnail.duration',
            },
            { path: 'entity.description.nodes.galleryData.options.item.ratio' },
            { path: 'entity.description.nodes.imageData.image.duration' },
            { path: 'entity.description.nodes.imageData.crop.x' },
            { path: 'entity.description.nodes.imageData.crop.y' },
            { path: 'entity.description.nodes.imageData.crop.width' },
            { path: 'entity.description.nodes.imageData.crop.height' },
            { path: 'entity.description.nodes.mapData.mapSettings.lat' },
            { path: 'entity.description.nodes.mapData.mapSettings.lng' },
            { path: 'entity.description.nodes.pollData.poll.image.duration' },
            {
              path: 'entity.description.nodes.pollData.poll.options.image.duration',
            },
            {
              path: 'entity.description.nodes.pollData.design.poll.background.image.duration',
            },
            { path: 'entity.description.nodes.appEmbedData.image.duration' },
            { path: 'entity.description.nodes.videoData.video.duration' },
            { path: 'entity.description.nodes.videoData.thumbnail.duration' },
            { path: 'entity.description.nodes.audioData.audio.duration' },
            { path: 'entity.description.nodes.audioData.coverImage.duration' },
            {
              path: 'entity.description.nodes.layoutData.backgroundImage.media.duration',
            },
            {
              path: 'entity.description.nodes.layoutData.backgroundImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.layoutData.backgroundImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.layoutData.backgroundImage.overlay.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.layoutData.backdropImage.media.duration',
            },
            {
              path: 'entity.description.nodes.layoutData.backdropImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.layoutData.backdropImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.layoutData.backdropImage.overlay.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.layoutData.background.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.layoutData.background.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.layoutData.background.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.layoutData.backdrop.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.layoutData.backdrop.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.layoutData.backdrop.gradient.stops.position',
            },
            { path: 'entity.description.nodes.shapeData.shape.duration' },
            {
              path: 'entity.description.nodes.cardData.background.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.cardData.background.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.cardData.background.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.cardData.backgroundImage.media.duration',
            },
            {
              path: 'entity.description.nodes.cardData.backgroundImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.cardData.backgroundImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.cardData.backgroundImage.overlay.gradient.stops.position',
            },
            { path: 'entity.description.nodes.tocData.fontSize' },
            { path: 'entity.description.nodes.tocData.itemSpacing' },
            {
              path: 'entity.description.nodes.smartBlockCellData.shape.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.background.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.background.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.background.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.backgroundHover.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.backgroundHover.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.galleryData.items.image.media.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.galleryData.items.video.media.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.galleryData.items.video.thumbnail.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.galleryData.options.item.ratio',
            },
            {
              path: 'entity.infoSections.description.nodes.imageData.image.duration',
            },
            { path: 'entity.infoSections.description.nodes.imageData.crop.x' },
            { path: 'entity.infoSections.description.nodes.imageData.crop.y' },
            {
              path: 'entity.infoSections.description.nodes.imageData.crop.width',
            },
            {
              path: 'entity.infoSections.description.nodes.imageData.crop.height',
            },
            {
              path: 'entity.infoSections.description.nodes.mapData.mapSettings.lat',
            },
            {
              path: 'entity.infoSections.description.nodes.mapData.mapSettings.lng',
            },
            {
              path: 'entity.infoSections.description.nodes.pollData.poll.image.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.pollData.poll.options.image.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.pollData.design.poll.background.image.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.appEmbedData.image.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.videoData.video.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.videoData.thumbnail.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.audioData.audio.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.audioData.coverImage.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backgroundImage.media.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backgroundImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backgroundImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backgroundImage.overlay.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdropImage.media.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdropImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdropImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdropImage.overlay.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.background.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.background.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.background.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdrop.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdrop.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdrop.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.shapeData.shape.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.background.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.background.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.background.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.backgroundImage.media.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.backgroundImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.backgroundImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.backgroundImage.overlay.gradient.stops.position',
            },
            { path: 'entity.infoSections.description.nodes.tocData.fontSize' },
            {
              path: 'entity.infoSections.description.nodes.tocData.itemSpacing',
            },
            {
              path: 'entity.infoSections.description.nodes.smartBlockCellData.shape.duration',
            },
            { path: 'entity.variantsInfo.variants.physicalProperties.weight' },
            {
              path: 'entity.variantSummary.minPriceVariant.physicalProperties.weight',
            },
            { path: 'entity.minVariantPriceInfo.weight' },
          ],
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [
            { path: 'entity.media.main.image' },
            { path: 'entity.media.itemsInfo.items.image' },
            { path: 'entity.options.choicesSettings.choices.image' },
            { path: 'entity.options.choicesSettings.choices.displayImage' },
            {
              path: 'entity.options.choicesSettings.choices.linkedMedia.image',
            },
            { path: 'entity.modifiers.choicesSettings.choices.image' },
            { path: 'entity.modifiers.choicesSettings.choices.displayImage' },
            {
              path: 'entity.modifiers.choicesSettings.choices.linkedMedia.image',
            },
            { path: 'entity.variantsInfo.variants.media.image' },
            { path: 'entity.variantSummary.minPriceVariant.media.image' },
          ],
        },
        {
          transformFn: transformRESTVideoV2ToSDKVideoV2,
          paths: [
            { path: 'entity.media.main.video' },
            { path: 'entity.media.itemsInfo.items.video' },
            {
              path: 'entity.options.choicesSettings.choices.linkedMedia.video',
            },
            {
              path: 'entity.modifiers.choicesSettings.choices.linkedMedia.video',
            },
            { path: 'entity.variantsInfo.variants.media.video' },
            { path: 'entity.variantSummary.minPriceVariant.media.video' },
          ],
        },
      ])
    )
)<ProductDeletedEnvelope>();
export const onProductUpdated = EventDefinition(
  'wix.stores.catalog.v3.product_updated',
  true,
  (event: ProductUpdatedEnvelope) =>
    renameKeysFromRESTResponseToSDKResponse(
      transformPaths(event, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: 'entity.createdDate' },
            { path: 'entity.updatedDate' },
            { path: 'entity.description.metadata.createdTimestamp' },
            { path: 'entity.description.metadata.updatedTimestamp' },
            {
              path: 'entity.infoSections.description.metadata.createdTimestamp',
            },
            {
              path: 'entity.infoSections.description.metadata.updatedTimestamp',
            },
            { path: 'metadata.eventTime' },
            { path: 'modifiedFields.createdDate' },
            { path: 'modifiedFields.updatedDate' },
            { path: 'modifiedFields.description.metadata.createdTimestamp' },
            { path: 'modifiedFields.description.metadata.updatedTimestamp' },
            {
              path: 'modifiedFields.infoSections.description.metadata.createdTimestamp',
            },
            {
              path: 'modifiedFields.infoSections.description.metadata.updatedTimestamp',
            },
          ],
        },
        {
          transformFn: transformRESTPageURLV2ToSDKPageURLV2,
          paths: [{ path: 'entity.url' }, { path: 'modifiedFields.url' }],
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: 'entity.physicalProperties.pricePerUnit.quantity' },
            { path: 'entity.physicalProperties.shippingWeightRange.minValue' },
            { path: 'entity.physicalProperties.shippingWeightRange.maxValue' },
            {
              path: 'entity.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity',
            },
            {
              path: 'entity.variantsInfo.variants.revenueDetails.profitMargin',
            },
            {
              path: 'entity.subscriptionDetails.subscriptions.discount.percentOff',
            },
            {
              path: 'entity.variantSummary.minPriceVariant.physicalProperties.pricePerUnit.settings.quantity',
            },
            {
              path: 'entity.variantSummary.minPriceVariant.revenueDetails.profitMargin',
            },
            {
              path: 'entity.minVariantPriceInfo.pricePerUnitData.settings.quantity',
            },
            { path: 'entity.minVariantPriceInfo.revenueDetails.profitMargin' },
            {
              path: 'entity.description.nodes.buttonData.styles.background.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.buttonData.styles.background.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.buttonData.styles.background.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.buttonData.styles.backgroundHover.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.buttonData.styles.backgroundHover.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.galleryData.items.image.media.duration',
            },
            {
              path: 'entity.description.nodes.galleryData.items.video.media.duration',
            },
            {
              path: 'entity.description.nodes.galleryData.items.video.thumbnail.duration',
            },
            { path: 'entity.description.nodes.galleryData.options.item.ratio' },
            { path: 'entity.description.nodes.imageData.image.duration' },
            { path: 'entity.description.nodes.imageData.crop.x' },
            { path: 'entity.description.nodes.imageData.crop.y' },
            { path: 'entity.description.nodes.imageData.crop.width' },
            { path: 'entity.description.nodes.imageData.crop.height' },
            { path: 'entity.description.nodes.mapData.mapSettings.lat' },
            { path: 'entity.description.nodes.mapData.mapSettings.lng' },
            { path: 'entity.description.nodes.pollData.poll.image.duration' },
            {
              path: 'entity.description.nodes.pollData.poll.options.image.duration',
            },
            {
              path: 'entity.description.nodes.pollData.design.poll.background.image.duration',
            },
            { path: 'entity.description.nodes.appEmbedData.image.duration' },
            { path: 'entity.description.nodes.videoData.video.duration' },
            { path: 'entity.description.nodes.videoData.thumbnail.duration' },
            { path: 'entity.description.nodes.audioData.audio.duration' },
            { path: 'entity.description.nodes.audioData.coverImage.duration' },
            {
              path: 'entity.description.nodes.layoutData.backgroundImage.media.duration',
            },
            {
              path: 'entity.description.nodes.layoutData.backgroundImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.layoutData.backgroundImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.layoutData.backgroundImage.overlay.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.layoutData.backdropImage.media.duration',
            },
            {
              path: 'entity.description.nodes.layoutData.backdropImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.layoutData.backdropImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.layoutData.backdropImage.overlay.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.layoutData.background.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.layoutData.background.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.layoutData.background.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.layoutData.backdrop.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.layoutData.backdrop.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.layoutData.backdrop.gradient.stops.position',
            },
            { path: 'entity.description.nodes.shapeData.shape.duration' },
            {
              path: 'entity.description.nodes.cardData.background.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.cardData.background.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.cardData.background.gradient.stops.position',
            },
            {
              path: 'entity.description.nodes.cardData.backgroundImage.media.duration',
            },
            {
              path: 'entity.description.nodes.cardData.backgroundImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.description.nodes.cardData.backgroundImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.description.nodes.cardData.backgroundImage.overlay.gradient.stops.position',
            },
            { path: 'entity.description.nodes.tocData.fontSize' },
            { path: 'entity.description.nodes.tocData.itemSpacing' },
            {
              path: 'entity.description.nodes.smartBlockCellData.shape.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.background.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.background.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.background.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.backgroundHover.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.backgroundHover.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.galleryData.items.image.media.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.galleryData.items.video.media.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.galleryData.items.video.thumbnail.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.galleryData.options.item.ratio',
            },
            {
              path: 'entity.infoSections.description.nodes.imageData.image.duration',
            },
            { path: 'entity.infoSections.description.nodes.imageData.crop.x' },
            { path: 'entity.infoSections.description.nodes.imageData.crop.y' },
            {
              path: 'entity.infoSections.description.nodes.imageData.crop.width',
            },
            {
              path: 'entity.infoSections.description.nodes.imageData.crop.height',
            },
            {
              path: 'entity.infoSections.description.nodes.mapData.mapSettings.lat',
            },
            {
              path: 'entity.infoSections.description.nodes.mapData.mapSettings.lng',
            },
            {
              path: 'entity.infoSections.description.nodes.pollData.poll.image.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.pollData.poll.options.image.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.pollData.design.poll.background.image.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.appEmbedData.image.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.videoData.video.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.videoData.thumbnail.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.audioData.audio.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.audioData.coverImage.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backgroundImage.media.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backgroundImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backgroundImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backgroundImage.overlay.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdropImage.media.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdropImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdropImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdropImage.overlay.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.background.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.background.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.background.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdrop.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdrop.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.layoutData.backdrop.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.shapeData.shape.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.background.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.background.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.background.gradient.stops.position',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.backgroundImage.media.duration',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.backgroundImage.overlay.gradient.centerX',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.backgroundImage.overlay.gradient.centerY',
            },
            {
              path: 'entity.infoSections.description.nodes.cardData.backgroundImage.overlay.gradient.stops.position',
            },
            { path: 'entity.infoSections.description.nodes.tocData.fontSize' },
            {
              path: 'entity.infoSections.description.nodes.tocData.itemSpacing',
            },
            {
              path: 'entity.infoSections.description.nodes.smartBlockCellData.shape.duration',
            },
            { path: 'entity.variantsInfo.variants.physicalProperties.weight' },
            {
              path: 'entity.variantSummary.minPriceVariant.physicalProperties.weight',
            },
            { path: 'entity.minVariantPriceInfo.weight' },
            { path: 'modifiedFields.physicalProperties.pricePerUnit.quantity' },
            {
              path: 'modifiedFields.physicalProperties.shippingWeightRange.minValue',
            },
            {
              path: 'modifiedFields.physicalProperties.shippingWeightRange.maxValue',
            },
            {
              path: 'modifiedFields.variantsInfo.variants.physicalProperties.pricePerUnit.settings.quantity',
            },
            {
              path: 'modifiedFields.variantsInfo.variants.revenueDetails.profitMargin',
            },
            {
              path: 'modifiedFields.subscriptionDetails.subscriptions.discount.percentOff',
            },
            {
              path: 'modifiedFields.variantSummary.minPriceVariant.physicalProperties.pricePerUnit.settings.quantity',
            },
            {
              path: 'modifiedFields.variantSummary.minPriceVariant.revenueDetails.profitMargin',
            },
            {
              path: 'modifiedFields.minVariantPriceInfo.pricePerUnitData.settings.quantity',
            },
            {
              path: 'modifiedFields.minVariantPriceInfo.revenueDetails.profitMargin',
            },
            {
              path: 'modifiedFields.description.nodes.buttonData.styles.background.gradient.centerX',
            },
            {
              path: 'modifiedFields.description.nodes.buttonData.styles.background.gradient.centerY',
            },
            {
              path: 'modifiedFields.description.nodes.buttonData.styles.background.gradient.stops.position',
            },
            {
              path: 'modifiedFields.description.nodes.buttonData.styles.backgroundHover.gradient.centerX',
            },
            {
              path: 'modifiedFields.description.nodes.buttonData.styles.backgroundHover.gradient.centerY',
            },
            {
              path: 'modifiedFields.description.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
            },
            {
              path: 'modifiedFields.description.nodes.galleryData.items.image.media.duration',
            },
            {
              path: 'modifiedFields.description.nodes.galleryData.items.video.media.duration',
            },
            {
              path: 'modifiedFields.description.nodes.galleryData.items.video.thumbnail.duration',
            },
            {
              path: 'modifiedFields.description.nodes.galleryData.options.item.ratio',
            },
            {
              path: 'modifiedFields.description.nodes.imageData.image.duration',
            },
            { path: 'modifiedFields.description.nodes.imageData.crop.x' },
            { path: 'modifiedFields.description.nodes.imageData.crop.y' },
            { path: 'modifiedFields.description.nodes.imageData.crop.width' },
            { path: 'modifiedFields.description.nodes.imageData.crop.height' },
            {
              path: 'modifiedFields.description.nodes.mapData.mapSettings.lat',
            },
            {
              path: 'modifiedFields.description.nodes.mapData.mapSettings.lng',
            },
            {
              path: 'modifiedFields.description.nodes.pollData.poll.image.duration',
            },
            {
              path: 'modifiedFields.description.nodes.pollData.poll.options.image.duration',
            },
            {
              path: 'modifiedFields.description.nodes.pollData.design.poll.background.image.duration',
            },
            {
              path: 'modifiedFields.description.nodes.appEmbedData.image.duration',
            },
            {
              path: 'modifiedFields.description.nodes.videoData.video.duration',
            },
            {
              path: 'modifiedFields.description.nodes.videoData.thumbnail.duration',
            },
            {
              path: 'modifiedFields.description.nodes.audioData.audio.duration',
            },
            {
              path: 'modifiedFields.description.nodes.audioData.coverImage.duration',
            },
            {
              path: 'modifiedFields.description.nodes.layoutData.backgroundImage.media.duration',
            },
            {
              path: 'modifiedFields.description.nodes.layoutData.backgroundImage.overlay.gradient.centerX',
            },
            {
              path: 'modifiedFields.description.nodes.layoutData.backgroundImage.overlay.gradient.centerY',
            },
            {
              path: 'modifiedFields.description.nodes.layoutData.backgroundImage.overlay.gradient.stops.position',
            },
            {
              path: 'modifiedFields.description.nodes.layoutData.backdropImage.media.duration',
            },
            {
              path: 'modifiedFields.description.nodes.layoutData.backdropImage.overlay.gradient.centerX',
            },
            {
              path: 'modifiedFields.description.nodes.layoutData.backdropImage.overlay.gradient.centerY',
            },
            {
              path: 'modifiedFields.description.nodes.layoutData.backdropImage.overlay.gradient.stops.position',
            },
            {
              path: 'modifiedFields.description.nodes.layoutData.background.gradient.centerX',
            },
            {
              path: 'modifiedFields.description.nodes.layoutData.background.gradient.centerY',
            },
            {
              path: 'modifiedFields.description.nodes.layoutData.background.gradient.stops.position',
            },
            {
              path: 'modifiedFields.description.nodes.layoutData.backdrop.gradient.centerX',
            },
            {
              path: 'modifiedFields.description.nodes.layoutData.backdrop.gradient.centerY',
            },
            {
              path: 'modifiedFields.description.nodes.layoutData.backdrop.gradient.stops.position',
            },
            {
              path: 'modifiedFields.description.nodes.shapeData.shape.duration',
            },
            {
              path: 'modifiedFields.description.nodes.cardData.background.gradient.centerX',
            },
            {
              path: 'modifiedFields.description.nodes.cardData.background.gradient.centerY',
            },
            {
              path: 'modifiedFields.description.nodes.cardData.background.gradient.stops.position',
            },
            {
              path: 'modifiedFields.description.nodes.cardData.backgroundImage.media.duration',
            },
            {
              path: 'modifiedFields.description.nodes.cardData.backgroundImage.overlay.gradient.centerX',
            },
            {
              path: 'modifiedFields.description.nodes.cardData.backgroundImage.overlay.gradient.centerY',
            },
            {
              path: 'modifiedFields.description.nodes.cardData.backgroundImage.overlay.gradient.stops.position',
            },
            { path: 'modifiedFields.description.nodes.tocData.fontSize' },
            { path: 'modifiedFields.description.nodes.tocData.itemSpacing' },
            {
              path: 'modifiedFields.description.nodes.smartBlockCellData.shape.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.buttonData.styles.background.gradient.centerX',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.buttonData.styles.background.gradient.centerY',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.buttonData.styles.background.gradient.stops.position',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.buttonData.styles.backgroundHover.gradient.centerX',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.buttonData.styles.backgroundHover.gradient.centerY',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.buttonData.styles.backgroundHover.gradient.stops.position',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.galleryData.items.image.media.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.galleryData.items.video.media.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.galleryData.items.video.thumbnail.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.galleryData.options.item.ratio',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.imageData.image.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.imageData.crop.x',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.imageData.crop.y',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.imageData.crop.width',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.imageData.crop.height',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.mapData.mapSettings.lat',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.mapData.mapSettings.lng',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.pollData.poll.image.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.pollData.poll.options.image.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.pollData.design.poll.background.image.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.appEmbedData.image.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.videoData.video.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.videoData.thumbnail.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.audioData.audio.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.audioData.coverImage.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.layoutData.backgroundImage.media.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.layoutData.backgroundImage.overlay.gradient.centerX',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.layoutData.backgroundImage.overlay.gradient.centerY',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.layoutData.backgroundImage.overlay.gradient.stops.position',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.layoutData.backdropImage.media.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.layoutData.backdropImage.overlay.gradient.centerX',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.layoutData.backdropImage.overlay.gradient.centerY',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.layoutData.backdropImage.overlay.gradient.stops.position',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.layoutData.background.gradient.centerX',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.layoutData.background.gradient.centerY',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.layoutData.background.gradient.stops.position',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.layoutData.backdrop.gradient.centerX',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.layoutData.backdrop.gradient.centerY',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.layoutData.backdrop.gradient.stops.position',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.shapeData.shape.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.cardData.background.gradient.centerX',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.cardData.background.gradient.centerY',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.cardData.background.gradient.stops.position',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.cardData.backgroundImage.media.duration',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.cardData.backgroundImage.overlay.gradient.centerX',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.cardData.backgroundImage.overlay.gradient.centerY',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.cardData.backgroundImage.overlay.gradient.stops.position',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.tocData.fontSize',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.tocData.itemSpacing',
            },
            {
              path: 'modifiedFields.infoSections.description.nodes.smartBlockCellData.shape.duration',
            },
            {
              path: 'modifiedFields.variantsInfo.variants.physicalProperties.weight',
            },
            {
              path: 'modifiedFields.variantSummary.minPriceVariant.physicalProperties.weight',
            },
            { path: 'modifiedFields.minVariantPriceInfo.weight' },
          ],
        },
        {
          transformFn: transformRESTImageToSDKImage,
          paths: [
            { path: 'entity.media.main.image' },
            { path: 'entity.media.itemsInfo.items.image' },
            { path: 'entity.options.choicesSettings.choices.image' },
            { path: 'entity.options.choicesSettings.choices.displayImage' },
            {
              path: 'entity.options.choicesSettings.choices.linkedMedia.image',
            },
            { path: 'entity.modifiers.choicesSettings.choices.image' },
            { path: 'entity.modifiers.choicesSettings.choices.displayImage' },
            {
              path: 'entity.modifiers.choicesSettings.choices.linkedMedia.image',
            },
            { path: 'entity.variantsInfo.variants.media.image' },
            { path: 'entity.variantSummary.minPriceVariant.media.image' },
            { path: 'modifiedFields.media.main.image' },
            { path: 'modifiedFields.media.itemsInfo.items.image' },
            { path: 'modifiedFields.options.choicesSettings.choices.image' },
            {
              path: 'modifiedFields.options.choicesSettings.choices.displayImage',
            },
            {
              path: 'modifiedFields.options.choicesSettings.choices.linkedMedia.image',
            },
            { path: 'modifiedFields.modifiers.choicesSettings.choices.image' },
            {
              path: 'modifiedFields.modifiers.choicesSettings.choices.displayImage',
            },
            {
              path: 'modifiedFields.modifiers.choicesSettings.choices.linkedMedia.image',
            },
            { path: 'modifiedFields.variantsInfo.variants.media.image' },
            {
              path: 'modifiedFields.variantSummary.minPriceVariant.media.image',
            },
          ],
        },
        {
          transformFn: transformRESTVideoV2ToSDKVideoV2,
          paths: [
            { path: 'entity.media.main.video' },
            { path: 'entity.media.itemsInfo.items.video' },
            {
              path: 'entity.options.choicesSettings.choices.linkedMedia.video',
            },
            {
              path: 'entity.modifiers.choicesSettings.choices.linkedMedia.video',
            },
            { path: 'entity.variantsInfo.variants.media.video' },
            { path: 'entity.variantSummary.minPriceVariant.media.video' },
            { path: 'modifiedFields.media.main.video' },
            { path: 'modifiedFields.media.itemsInfo.items.video' },
            {
              path: 'modifiedFields.options.choicesSettings.choices.linkedMedia.video',
            },
            {
              path: 'modifiedFields.modifiers.choicesSettings.choices.linkedMedia.video',
            },
            { path: 'modifiedFields.variantsInfo.variants.media.video' },
            {
              path: 'modifiedFields.variantSummary.minPriceVariant.media.video',
            },
          ],
        },
      ])
    )
)<ProductUpdatedEnvelope>();

export {
  AccountInfo,
  AccountInfoMetadata,
  ActionEvent,
  AddressLocation,
  AdjustValue,
  AdjustValueAdjustValueOneOf,
  Aggregation,
  AggregationData,
  AggregationDataAggregationResults,
  AggregationDataAggregationResultsResultOneOf,
  AggregationDataAggregationResultsScalarResult,
  AggregationDateHistogramAggregation,
  AggregationDateHistogramAggregationInterval,
  AggregationKindOneOf,
  AggregationNestedAggregation,
  AggregationNestedAggregationNestedAggregationItem,
  AggregationNestedAggregationNestedAggregationItemKindOneOf,
  AggregationNestedAggregationNestedAggregationType,
  AggregationRangeAggregation,
  AggregationRangeAggregationRangeBucket,
  AggregationResults,
  AggregationResultsDateHistogramResults,
  AggregationResultsGroupByValueResults,
  AggregationResultsNestedAggregationResults,
  AggregationResultsNestedAggregationResultsResultOneOf,
  AggregationResultsNestedResults,
  AggregationResultsRangeResults,
  AggregationResultsResultOneOf,
  AggregationResultsScalarResult,
  AggregationResultsValueResults,
  AggregationScalarAggregation,
  AggregationType,
  AggregationValueAggregation,
  AggregationValueAggregationIncludeMissingValuesOptions,
  AggregationValueAggregationMissingValues,
  AggregationValueAggregationOptionsOneOf,
  AggregationValueAggregationSortDirection,
  AggregationValueAggregationSortType,
  Alignment,
  AnchorData,
  App,
  AppEmbedData,
  AppEmbedDataAppDataOneOf,
  AppType,
  ApplicationError,
  AspectRatio,
  AudioData,
  AvailabilityStatus,
  Backdrop,
  BackdropType,
  Background,
  BackgroundGradient,
  BackgroundImage,
  BackgroundType,
  Banner,
  BannerPosition,
  BaseEventMetadata,
  BlockquoteData,
  BookingData,
  Border,
  BorderColors,
  BorderWidths,
  Brand,
  BreadCrumb,
  BreadcrumbsInfo,
  BulkActionMetadata,
  BulkAddInfoSectionsToProductsByFilterOptions,
  BulkAddInfoSectionsToProductsByFilterRequest,
  BulkAddInfoSectionsToProductsByFilterResponse,
  BulkAddInfoSectionsToProductsOptions,
  BulkAddInfoSectionsToProductsRequest,
  BulkAddInfoSectionsToProductsResponse,
  BulkAddProductsToCategoriesByFilterOptions,
  BulkAddProductsToCategoriesByFilterRequest,
  BulkAddProductsToCategoriesByFilterResponse,
  BulkAdjustProductVariantsByFilterOptions,
  BulkAdjustProductVariantsByFilterRequest,
  BulkAdjustProductVariantsByFilterRequestRoundingStrategy,
  BulkAdjustProductVariantsByFilterResponse,
  BulkCreateProductsForMigrationRequest,
  BulkCreateProductsForMigrationResponse,
  BulkCreateProductsOptions,
  BulkCreateProductsRequest,
  BulkCreateProductsResponse,
  BulkCreateProductsWithInventoryForMigrationRequest,
  BulkCreateProductsWithInventoryForMigrationResponse,
  BulkCreateProductsWithInventoryOptions,
  BulkCreateProductsWithInventoryRequest,
  BulkCreateProductsWithInventoryResponse,
  BulkDeleteProductsByFilterOptions,
  BulkDeleteProductsByFilterRequest,
  BulkDeleteProductsByFilterResponse,
  BulkDeleteProductsRequest,
  BulkDeleteProductsResponse,
  BulkDeleteProductsResponseBulkProductResult,
  BulkInventoryItemAction,
  BulkInventoryItemResult,
  BulkInventoryItemResults,
  BulkProductResult,
  BulkProductResults,
  BulkRemoveInfoSectionsFromProductsByFilterOptions,
  BulkRemoveInfoSectionsFromProductsByFilterRequest,
  BulkRemoveInfoSectionsFromProductsByFilterResponse,
  BulkRemoveInfoSectionsFromProductsOptions,
  BulkRemoveInfoSectionsFromProductsRequest,
  BulkRemoveInfoSectionsFromProductsResponse,
  BulkRemoveProductsFromCategoriesByFilterOptions,
  BulkRemoveProductsFromCategoriesByFilterRequest,
  BulkRemoveProductsFromCategoriesByFilterResponse,
  BulkUpdateProductTagsByFilterOptions,
  BulkUpdateProductTagsByFilterRequest,
  BulkUpdateProductTagsByFilterResponse,
  BulkUpdateProductTagsOptions,
  BulkUpdateProductTagsRequest,
  BulkUpdateProductTagsResponse,
  BulkUpdateProductTagsResponseBulkUpdateProductTagsResult,
  BulkUpdateProductTagsResult,
  BulkUpdateProductVariantsByFilterOptions,
  BulkUpdateProductVariantsByFilterRequest,
  BulkUpdateProductVariantsByFilterResponse,
  BulkUpdateProductsByFilterOptions,
  BulkUpdateProductsByFilterRequest,
  BulkUpdateProductsByFilterResponse,
  BulkUpdateProductsOptions,
  BulkUpdateProductsRequest,
  BulkUpdateProductsResponse,
  BulkUpdateProductsWithInventoryOptions,
  BulkUpdateProductsWithInventoryRequest,
  BulkUpdateProductsWithInventoryResponse,
  BulkUpdateVariantsByFilterRequest,
  BulkUpdateVariantsByFilterResponse,
  BulletedListData,
  ButtonData,
  ButtonDataType,
  ButtonStyles,
  CalculateProductInventorPreorderStatusAsyncRequest,
  CalculateProductInventorPreorderStatusAsyncResponse,
  CaptionData,
  CardData,
  CardDataBackground,
  CardDataBackgroundType,
  CardStyles,
  CatalogRollbackRequested,
  CatalogV3BulkProductResult,
  CellStyle,
  CheckboxListData,
  ChoiceType,
  ChoicesSettings,
  CodeBlockData,
  CollapsibleListData,
  ColorData,
  Colors,
  ColumnSize,
  CommonAggregation,
  CommonAggregationData,
  CommonAggregationDateHistogramAggregation,
  CommonAggregationKindOneOf,
  CommonAggregationNestedAggregation,
  CommonAggregationRangeAggregation,
  CommonAggregationScalarAggregation,
  CommonAggregationType,
  CommonAggregationValueAggregation,
  CommonAggregationValueAggregationOptionsOneOf,
  CommonBulkActionMetadata,
  CommonCursorPaging,
  CommonCursorPagingMetadata,
  CommonCursorQuery,
  CommonCursorQueryPagingMethodOneOf,
  CommonCursorSearch,
  CommonCursorSearchPagingMethodOneOf,
  CommonCursors,
  CommonItemMetadata,
  CommonScalarType,
  CommonSearchDetails,
  CommonSearchDetailsMode,
  CommonSortOrder,
  CommonSorting,
  ConnectedModifier,
  ConnectedModifierChoice,
  ConnectedModifierChoiceValueOneOf,
  ConnectedModifierModifierSettingsOneOf,
  ConnectedOption,
  ConnectedOptionChoice,
  ConnectedOptionChoiceValueOneOf,
  ConnectedOptionOptionSettingsOneOf,
  CountProductsOptions,
  CountProductsRequest,
  CountProductsResponse,
  CreateProductOptions,
  CreateProductRequest,
  CreateProductResponse,
  CreateProductWithInventoryOptions,
  CreateProductWithInventoryRequest,
  CreateProductWithInventoryResponse,
  Crop,
  CursorPaging,
  CursorPagingMetadata,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  CursorSearch,
  CursorSearchPagingMethodOneOf,
  Cursors,
  CustomTag,
  DateHistogramAggregation,
  DateHistogramAggregationInterval,
  DateHistogramResult,
  DateHistogramResults,
  DateHistogramResultsDateHistogramResult,
  Decoration,
  DecorationDataOneOf,
  DecorationType,
  DeleteByFilterOperation,
  DeleteByIdsOperation,
  DeleteProductRequest,
  DeleteProductResponse,
  DeprecatedSearchProductsWithOffsetRequest,
  DeprecatedSearchProductsWithOffsetResponse,
  Design,
  DesignTarget,
  Dimensions,
  DimensionsUnit,
  Direction,
  DiscountInfo,
  DiscountType,
  DividerData,
  DividerDataAlignment,
  DoNotCallBulkCreateProductsRequest,
  DoNotCallBulkCreateProductsResponse,
  DoNotCallBulkUpdateProductsRequest,
  DoNotCallBulkUpdateProductsResponse,
  DoNotCallCreateProductRequest,
  DoNotCallCreateProductResponse,
  DoNotCallUpdateProductRequest,
  DoNotCallUpdateProductResponse,
  DocumentImage,
  DocumentPayload,
  DocumentStyle,
  DocumentUpdateOperation,
  DomainEvent,
  DomainEventBodyOneOf,
  DuplicateMediaIdAssignedToProduct,
  DuplicateRibbonErrorData,
  EmbedData,
  Empty,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  Enum,
  EventData,
  EventMetadata,
  EventType,
  EventuallyConsistentQueryProductsRequest,
  EventuallyConsistentQueryProductsResponse,
  ExtendedFields,
  File,
  FileData,
  FileSource,
  FileSourceDataOneOf,
  FileType,
  FixedMonetaryAmount,
  FontFamilyData,
  FontSizeData,
  FontType,
  FreeTextSettings,
  FulfillerDeleted,
  GIF,
  GIFData,
  GIFType,
  GalleryData,
  GalleryOptions,
  GalleryOptionsLayout,
  GeotileGridAggregation,
  GetAllProductsCategoryRequest,
  GetAllProductsCategoryResponse,
  GetProductBySlugOptions,
  GetProductBySlugRequest,
  GetProductBySlugResponse,
  GetProductOptions,
  GetProductRequest,
  GetProductResponse,
  Gradient,
  GradientType,
  GroupByAggregation,
  GroupByAggregationKindOneOf,
  GroupByValueResults,
  GroupByValueResultsNestedValueAggregationResult,
  HTMLData,
  HTMLDataDataOneOf,
  HeadingData,
  Height,
  IdentificationData,
  IdentificationDataIdOneOf,
  Image,
  ImageData,
  ImageDataCrop,
  ImageDataStyles,
  ImagePosition,
  ImagePositionPosition,
  ImageScalingScaling,
  ImageStyles,
  IncludeMissingValuesOptions,
  Indentation,
  IndexDocument,
  InfoSection,
  InitialExpandedItems,
  Interval,
  InvalidDigitalFileIds,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  Inventory,
  InventoryAvailabilityStatus,
  InventoryItem,
  InventoryItemComposite,
  InventoryItemCompositeForMigration,
  InventoryItemCompositeForMigrationTrackingMethodOneOf,
  InventoryItemCompositeTrackingMethodOneOf,
  InventoryItemTrackingMethodOneOf,
  InventoryStatus,
  Item,
  ItemDataOneOf,
  ItemMetadata,
  ItemStyle,
  Keyword,
  Layout,
  LayoutCellData,
  LayoutData,
  LayoutDataBackground,
  LayoutDataBackgroundImage,
  LayoutDataBackgroundType,
  LayoutType,
  LineStyle,
  Link,
  LinkData,
  LinkDataOneOf,
  LinkPreviewData,
  LinkPreviewDataStyles,
  ListItemNodeData,
  ListStyle,
  ListValue,
  MapData,
  MapSettings,
  MapType,
  MaskedProduct,
  MaskedProductWithInventory,
  MeasurementUnit,
  Media,
  MediaItemsInfo,
  MediaReference,
  MediaReferenceIdentifierOneOf,
  MediaReferences,
  MediaType,
  MentionData,
  MessageEnvelope,
  Metadata,
  MinVariantPriceInfo,
  MissingValues,
  MissingVariantOptionChoiceErrorData,
  MissingVariantOptionErrorData,
  Mode,
  ModifierChoicesSettings,
  ModifierRenderType,
  MultipleColors,
  NestedAggregation,
  NestedAggregationItem,
  NestedAggregationItemKindOneOf,
  NestedAggregationNestedAggregationItem,
  NestedAggregationNestedAggregationItemKindOneOf,
  NestedAggregationNestedAggregationType,
  NestedAggregationResults,
  NestedAggregationResultsResultOneOf,
  NestedAggregationType,
  NestedResultValue,
  NestedResultValueResultOneOf,
  NestedResults,
  NestedResultsNestedResultValue,
  NestedResultsNestedResultValueResultOneOf,
  NestedResultsRangeResult,
  NestedResultsResults,
  NestedResultsScalarResult,
  NestedResultsValueResult,
  NestedValueAggregationResult,
  Node,
  NodeDataOneOf,
  NodeStyle,
  NodeType,
  NullValue,
  Oembed,
  Option,
  OptionChoice,
  OptionChoiceIds,
  OptionChoiceIdsForMigration,
  OptionChoiceNames,
  OptionChoiceReferences,
  OptionChoiceReferencesForMigration,
  OptionDesign,
  OptionLayout,
  OrderedListData,
  Orientation,
  Origin,
  PDFSettings,
  Page,
  Pages,
  PagingMetadata,
  ParagraphData,
  Permissions,
  PhysicalProperties,
  Placement,
  PlatformOffsetSearch,
  PlatformOffsetSearchPagingMethodOneOf,
  PlatformPaging,
  PlaybackOptions,
  PluginContainerData,
  PluginContainerDataAlignment,
  PluginContainerDataWidth,
  PluginContainerDataWidthDataOneOf,
  Poll,
  PollData,
  PollDataLayout,
  PollDesign,
  PollDesignBackground,
  PollDesignBackgroundBackgroundOneOf,
  PollDesignBackgroundType,
  PollLayout,
  PollLayoutDirection,
  PollLayoutType,
  PollSettings,
  Position,
  PreorderInfo,
  PreorderStatus,
  PriceInfo,
  PricePerUnit,
  PricePerUnitRange,
  PricePerUnitRangePricePerUnit,
  PricePerUnitSettings,
  PriceRange,
  PricingData,
  Product,
  ProductCategoriesInfo,
  ProductCategory,
  ProductCategoryIdsInfo,
  ProductCreatedEnvelope,
  ProductDeletedEnvelope,
  ProductIdWithRevision,
  ProductMedia,
  ProductMediaMediaOneOf,
  ProductMediaSetByOneOf,
  ProductOptionRenderType,
  ProductPreorderAvailability,
  ProductTagsModified,
  ProductType,
  ProductUpdatedEnvelope,
  ProductVariantIds,
  ProductVariants,
  ProductWithInventory,
  ProductWithInventoryForMigration,
  ProductWithInventoryForMigrationTypedPropertiesOneOf,
  ProductWithInventoryTypedPropertiesOneOf,
  ProductsQueryBuilder,
  ProductsQueryResult,
  PuffUpProductMediaRequest,
  PuffUpProductMediaResponse,
  PurchaseEligibility,
  QueryProductsOptions,
  QueryProductsRequest,
  QueryProductsResponse,
  RangeAggregation,
  RangeAggregationRangeBucket,
  RangeAggregationResult,
  RangeBucket,
  RangeResult,
  RangeResults,
  RangeResultsRangeAggregationResult,
  ReconcileStaleCategorySortIndicesRequest,
  ReconcileStaleCategorySortIndicesResponse,
  Rel,
  RequestedFields,
  Resizing,
  ResponsivenessBehaviour,
  RestoreInfo,
  Results,
  RetrieveVariantsRequest,
  RetrieveVariantsResponse,
  RevenueDetails,
  Ribbon,
  RibbonStyles,
  RichContent,
  RoundingStrategy,
  ScalarAggregation,
  ScalarResult,
  ScalarType,
  Scaling,
  SearchDetails,
  SearchDetailsMode,
  SearchIndexingNotification,
  SearchProductsOptions,
  SearchProductsRequest,
  SearchProductsResponse,
  SearchRelated,
  SearchRelatedDetails,
  SearchRelatedProductsRequest,
  SearchRelatedProductsResponse,
  SecuredMedia,
  SeoSchema,
  Settings,
  ShapeData,
  ShapeDataStyles,
  SingleEntityOpsRequestedFields,
  SketchData,
  SketchDataVariant,
  SmartBlockCellData,
  SmartBlockData,
  SmartBlockDataType,
  SortDirection,
  SortOrder,
  SortType,
  Sorting,
  Source,
  Spoiler,
  SpoilerData,
  State,
  Stop,
  Styles,
  StylesBorder,
  StylesPosition,
  Subscription,
  SubscriptionCyclesOneOf,
  SubscriptionDetails,
  SubscriptionDiscount,
  SubscriptionDiscountDiscountOneOf,
  SubscriptionFrequency,
  SubscriptionPrice,
  SubscriptionPricePerUnit,
  SubscriptionPricesInfo,
  TableCellData,
  TableData,
  TableDataDimensions,
  Tag,
  TagList,
  Tags,
  Target,
  TextAlignment,
  TextData,
  TextNodeStyle,
  TextStyle,
  Thumbnail,
  Thumbnails,
  ThumbnailsAlignment,
  TocData,
  TreeReference,
  Type,
  URI,
  URIs,
  UnsignedAdjustValue,
  UnsignedAdjustValueAdjustValueOneOf,
  UnsupportedFieldMasks,
  UpdateByFilterOperation,
  UpdateDocumentsEvent,
  UpdateDocumentsEventOperationOneOf,
  UpdateExistingOperation,
  UpdateProduct,
  UpdateProductOptions,
  UpdateProductRequest,
  UpdateProductResponse,
  UpdateProductWithInventoryOptions,
  UpdateProductWithInventoryProduct,
  UpdateProductWithInventoryRequest,
  UpdateProductWithInventoryResponse,
  UserCriteria,
  V1Media,
  V3AdjustValue,
  V3AdjustValueAdjustValueOneOf,
  V3Brand,
  V3BulkAddInfoSectionsToProductsByFilterRequest,
  V3BulkAddInfoSectionsToProductsByFilterResponse,
  V3BulkAddInfoSectionsToProductsRequest,
  V3BulkAddInfoSectionsToProductsResponse,
  V3BulkAdjustProductVariantsByFilterRequest,
  V3BulkAdjustProductVariantsByFilterResponse,
  V3BulkDeleteProductsByFilterRequest,
  V3BulkDeleteProductsByFilterResponse,
  V3BulkDeleteProductsRequest,
  V3BulkDeleteProductsResponse,
  V3BulkProductResult,
  V3BulkRemoveInfoSectionsFromProductsByFilterRequest,
  V3BulkRemoveInfoSectionsFromProductsByFilterResponse,
  V3BulkRemoveInfoSectionsFromProductsRequest,
  V3BulkRemoveInfoSectionsFromProductsResponse,
  V3BulkUpdateProductTagsByFilterRequest,
  V3BulkUpdateProductTagsByFilterResponse,
  V3BulkUpdateProductTagsRequest,
  V3BulkUpdateProductTagsResponse,
  V3BulkUpdateProductsByFilterRequest,
  V3BulkUpdateProductsByFilterResponse,
  V3CountProductsRequest,
  V3CountProductsResponse,
  V3DeleteProductRequest,
  V3DeleteProductResponse,
  V3GetProductBySlugRequest,
  V3GetProductBySlugResponse,
  V3GetProductRequest,
  V3GetProductResponse,
  V3MaskedProduct,
  V3OptionChoiceIds,
  V3OptionChoiceNames,
  V3Product,
  V3ProductIdWithRevision,
  V3ProductQuerySpec,
  V3ProductSearchSpec,
  V3ProductTypedPropertiesOneOf,
  V3QueryProductsRequest,
  V3QueryProductsResponse,
  V3SearchProductsRequest,
  V3SearchProductsResponse,
  V3UnsignedAdjustValue,
  V3UnsignedAdjustValueAdjustValueOneOf,
  V3VariantsInfo,
  ValueAggregation,
  ValueAggregationIncludeMissingValuesOptions,
  ValueAggregationMissingValues,
  ValueAggregationOptionsOneOf,
  ValueAggregationResult,
  ValueAggregationSortDirection,
  ValueAggregationSortType,
  ValueResult,
  ValueResults,
  ValueResultsValueAggregationResult,
  Variant,
  VariantDigitalProperties,
  VariantNotAlignedWithProduct,
  VariantPhysicalProperties,
  VariantSummary,
  VariantTypedPropertiesOneOf,
  VariantWithInventory,
  VariantWithInventoryForMigration,
  VariantWithInventoryForMigrationTypedPropertiesOneOf,
  VariantWithInventoryTypedPropertiesOneOf,
  VariantsCursorPaging,
  VariantsInfo,
  VariantsInfoForMigration,
  VariantsNotAlignedWithProduct,
  VariantsOpsRequestedFields,
  VariantsRemoved,
  VerticalAlignment,
  VerticalAlignmentAlignment,
  Video,
  VideoData,
  VideoResolution,
  ViewMode,
  ViewRole,
  VoteRole,
  WebhookIdentityType,
  WeightMeasurementUnitInfo,
  WeightRange,
  WeightUnit,
  Width,
  WidthType,
  WixCommonAggregation,
  WixCommonAggregationKindOneOf,
  WixCommonAggregationType,
  WixCommonItemMetadata,
  WixCommonScalarType,
  WixCommonSearchDetails,
  WixCommonSortOrder,
  WixCommonSorting,
  utils,
} from './stores-catalog-v3-product-products-v-3.universal.js';
